﻿
document.documentElement.classList.add('js');
(function () {
  function markReady(fromNode) {
    var slider = fromNode && fromNode.closest ? fromNode.closest('.slider__product') : null;
    if (slider) slider.classList.add('cls-slider-ready');
  }
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      if (m.type === 'childList' && m.addedNodes) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('product-media-pagination')) {
            markReady(n); return;
          }
        }
      }
      if (m.type === 'attributes' && m.attributeName === 'style') {
        var t = m.target;
        if (t && t.classList && t.classList.contains('slider__inner')) {
          markReady(t); return;
        }
      }
    }
  });
  obs.observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['style']
  });
})();

(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function rafThrottle(fn) {
    var rafId = 0;
    return function () {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = 0;
        fn();
      });
    };
  }

  function currentVariantNode(form) {
    return form ? form.querySelector('input[name="id"], select[name="id"]') : null;
  }

  function currentVariantId(form) {
    var node = currentVariantNode(form);
    return node ? String(node.value) : null;
  }

  function initMediaCounter(sectionEl) {
    var productImages = sectionEl.querySelector('.product-images');
    var slider = productImages && productImages.querySelector('.slider__product');
    if (!slider || slider.dataset.idmMediaCounterInit === '1') return;
    slider.dataset.idmMediaCounterInit = '1';

    var badge = slider.querySelector('.product-media-pagination');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'product-media-pagination';
      slider.appendChild(badge);
    }

    function getVisibleItems(inner) {
      if (!inner) return [];
      return qsa(inner, '.slider__item').filter(function (item) {
        return item.offsetParent !== null && getComputedStyle(item).display !== 'none';
      });
    }

    function getCenteredIndex() {
      var inner = slider.querySelector('.slider__inner');
      var items = getVisibleItems(inner);
      var total = items.length;

      if (!total) return { index: 1, total: 0, centerItem: null };

      var frame = slider.querySelector('.slider__nav') || slider;
      var fr = frame.getBoundingClientRect();
      var cx = (fr.left + fr.right) / 2;

      var best = Infinity;
      var idx = 0;

      for (var i = 0; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        var ic = (r.left + r.right) / 2;
        var d = Math.abs(ic - cx);
        if (d < best) {
          best = d;
          idx = i;
        }
      }

      return { index: idx + 1, total: total, centerItem: items[idx] };
    }

    var updateBadge = rafThrottle(function () {
      var state = getCenteredIndex();
      if (state.total > 1) {
        var badgeText = state.index + ' / ' + state.total;
        if (badge.textContent !== badgeText) badge.textContent = badgeText;
        if (badge.style.display) badge.style.display = '';
      } else if (badge.style.display !== 'none') {
        badge.style.display = 'none';
      }
      var isVideoSlide = !!(state.centerItem && state.centerItem.classList.contains('product-size-guide3'));
      if (slider.classList.contains('is-on-video-slide') !== isVideoSlide) slider.classList.toggle('is-on-video-slide', isVideoSlide);
    });

    var currentInner = null;
    var moInner = null;

    function bindToInner(newInner) {
      if (!newInner || newInner === currentInner) return;

      if (moInner) {
        moInner.disconnect();
        moInner = null;
      }

      currentInner = newInner;
      currentInner.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') updateBadge();
      });
      currentInner.addEventListener('scroll', updateBadge, { passive: true });

      moInner = new MutationObserver(updateBadge);
      moInner.observe(currentInner, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      updateBadge();
    }

    var moSlider = new MutationObserver(function () {
      bindToInner(slider.querySelector('.slider__inner'));
      updateBadge();
    });

    moSlider.observe(slider, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    slider.addEventListener('click', function (e) {
      if (e.target.closest('.slider__previous, .slider__next')) {
        updateBadge();
      }
    }, { passive: true });

    window.addEventListener('resize', updateBadge, { passive: true });

    var form = document.getElementById('ajoute-panier');
    if (form) {
      form.addEventListener('change', updateBadge);
      form.addEventListener('input', updateBadge);

      var moForm = new MutationObserver(updateBadge);
      moForm.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value', 'checked', 'selected', 'class', 'style']
      });
    }

    ['variant:change', 'product:variant-change', 'theme:variant:change']
      .forEach(function (evt) {
        document.addEventListener(evt, updateBadge, true);
      });

    bindToInner(slider.querySelector('.slider__inner'));
    updateBadge();
  }

function initKlarnaBadge(sectionEl) {
  var badge = sectionEl.querySelector('klarna-placement[data-key="credit-promotion-badge"]');
  var form = document.getElementById('ajoute-panier');

  if (!badge || !form || badge.dataset.idmKlarnaInit === '1') return;
  badge.dataset.idmKlarnaInit = '1';

  var lastState = '';
  var refreshDebounce = null;
  var probeTimer = null;
  var sdkRetryTimer = null;

  function clearTimers() {
    if (refreshDebounce) {
      clearTimeout(refreshDebounce);
      refreshDebounce = null;
    }
    if (probeTimer) {
      clearTimeout(probeTimer);
      probeTimer = null;
    }
    if (sdkRetryTimer) {
      clearTimeout(sdkRetryTimer);
      sdkRetryTimer = null;
    }
  }

  function setState(state) {
    if (lastState === state) return;
    lastState = state;

    badge.classList.remove('klarna-loading', 'klarna-ready', 'klarna-empty');
    badge.classList.add('klarna-' + state);
    badge.setAttribute('aria-hidden', state === 'ready' ? 'false' : 'true');
  }

  function getSpinner() {
    return badge.querySelector('.klarna-spinner');
  }

  function ensureSpinner() {
    if (getSpinner()) return;

    var locale = (badge.getAttribute('data-locale') || 'fr-FR').toLowerCase();
    var isEn = locale.indexOf('en') === 0;
    var text = badge.getAttribute('data-spinner-text') ||
      (isEn
        ? 'Buy now, pay in 3 installments: Verifications in progress...'
        : 'Achetez maintenant, payez en 3 fois : Vérifications en cours…');

    var sk = document.createElement('div');
    sk.className = 'klarna-spinner';
    sk.innerHTML =
      '<div class="kskel"><div class="kdot"></div><div class="klines"><i></i><i></i></div></div>' +
      '<div class="ktext">' + text + '</div>';

    badge.appendChild(sk);
  }

  function removeSpinner() {
    var sk = getSpinner();
    if (!sk || !sk.parentNode) return;
    sk.parentNode.removeChild(sk);
  }

  function placementRendered() {
    if (badge.shadowRoot && badge.shadowRoot.childNodes && badge.shadowRoot.childNodes.length > 0) {
      return true;
    }

    if (badge.querySelector('iframe')) {
      return true;
    }

    var children = Array.prototype.slice.call(badge.children || []);
    return children.some(function (el) {
      return !el.classList.contains('klarna-spinner');
    });
  }

  function getCurrentAmount() {
    var vid = Number(currentVariantId(form));

    if (Array.isArray(window.variantsData)) {
      var variant = window.variantsData.find(function (v) {
        return Number(v.id) === vid;
      });

      if (variant && typeof variant.price !== 'undefined') {
        return Number(variant.price);
      }
    }

    var attr = badge.getAttribute('data-purchase-amount');
    return attr ? Number(attr) : null;
  }

  function probeRender(attempt) {
    if (placementRendered()) {
      removeSpinner();
      setState('ready');
      return;
    }

    if (attempt >= 14) {
      removeSpinner();
      setState('empty');
      return;
    }

    probeTimer = setTimeout(function () {
      probeRender(attempt + 1);
    }, attempt < 4 ? 250 : 500);
  }

  function refreshPlacements(retryCount) {
    if (
      window.Klarna &&
      window.Klarna.OnsiteMessaging &&
      typeof window.Klarna.OnsiteMessaging.refresh === 'function'
    ) {
      try {
        window.Klarna.OnsiteMessaging.refresh();
      } catch (e) {}
      probeRender(0);
      return;
    }

    if (retryCount >= 30) {
      removeSpinner();
      setState('empty');
      return;
    }

    sdkRetryTimer = setTimeout(function () {
      refreshPlacements(retryCount + 1);
    }, 200);
  }

  function updateKlarnaBadge() {
    clearTimers();

    var amount = getCurrentAmount();

    if (amount === null || !isFinite(amount) || amount <= 0) {
      removeSpinner();
      setState('empty');
      return;
    }

    if (lastState === 'ready' && badge.getAttribute('data-purchase-amount') === String(amount) && placementRendered()) return;

    badge.setAttribute('data-purchase-amount', String(amount));
    ensureSpinner();
    setState('loading');
    refreshPlacements(0);
  }

  function scheduleUpdate() {
    clearTimeout(refreshDebounce);
    refreshDebounce = setTimeout(updateKlarnaBadge, 120);
  }

  updateKlarnaBadge();

  form.addEventListener('change', scheduleUpdate);
  form.addEventListener('input', scheduleUpdate);

  ['variant:change', 'product:variant-change', 'theme:variant:change']
    .forEach(function (evt) {
      document.addEventListener(evt, scheduleUpdate, true);
    });
}

  function initVariantPackSync() {
    if (document.documentElement.dataset.idmVariantPackSyncInit === '1') return;
    document.documentElement.dataset.idmVariantPackSyncInit = '1';

    var isSyncing = false;
    var mainRoot = document.querySelector('.product-single') || document;
    var packIdSelects = document.querySelectorAll('.product-pack-item select.product-option-list[name="id"]');

    if (!packIdSelects.length) return;

    function triggerVariantEvents(el) {
      if (!el) return;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function runWithoutScrollJump(fn) {
      var x = window.scrollX || 0;
      var y = window.scrollY || 0;
      var origScrollIntoView = Element.prototype.scrollIntoView;
      var origFocus = HTMLElement.prototype.focus;

      Element.prototype.scrollIntoView = function () {};
      HTMLElement.prototype.focus = function () {};

      try {
        fn();
      } finally {
        Element.prototype.scrollIntoView = origScrollIntoView;
        HTMLElement.prototype.focus = origFocus;
        requestAnimationFrame(function () {
          window.scrollTo(x, y);
          requestAnimationFrame(function () { window.scrollTo(x, y); });
          setTimeout(function () { window.scrollTo(x, y); }, 0);
        });
      }
    }

    function getMainControl(pos) {
      var select = mainRoot.querySelector('select.product-option-list.select' + pos);
      if (select) return { type: 'select', el: select };

      var radios = mainRoot.querySelectorAll('input[name="option' + pos + '"]');
      if (radios && radios.length) return { type: 'radio', els: radios };

      return null;
    }

    function getMainSelectedValues() {
      var values = [];
      for (var pos = 1; pos <= 3; pos++) {
        var ctrl = getMainControl(pos);
        if (!ctrl) break;

        if (ctrl.type === 'select') {
          values.push(ctrl.el.value);
        } else {
          var checked = Array.prototype.find.call(ctrl.els, function (r) { return r.checked; });
          if (checked) values.push(checked.value);
        }
      }
      return values;
    }

    function setMainFromValues(values) {
      values.forEach(function (val, index) {
        var pos = index + 1;
        var ctrl = getMainControl(pos);
        if (!ctrl) return;

        if (ctrl.type === 'select') {
          if (ctrl.el.value !== val) ctrl.el.value = val;
          triggerVariantEvents(ctrl.el);
        } else {
          var radio = Array.prototype.find.call(ctrl.els, function (r) { return r.value === val; });
          if (!radio) return;
          if (!radio.checked) radio.checked = true;
          triggerVariantEvents(radio);
        }
      });
    }

    function syncPackFromMain() {
      var combinedTitle = getMainSelectedValues().join(' / ');
      Array.prototype.forEach.call(packIdSelects, function (select) {
        var match = Array.prototype.find.call(select.options, function (opt) {
          return opt.textContent.trim() === combinedTitle;
        });
        if (match && select.value !== match.value) {
          select.value = match.value;
          triggerVariantEvents(select);
        }
      });
    }

    function syncMainFromPack(changedPackSelect) {
      var selected = changedPackSelect.selectedOptions[0];
      var selectedText = selected && selected.textContent ? selected.textContent.trim() : '';
      if (!selectedText) return;

      var values = selectedText.split(' / ').map(function (s) { return s.trim(); });

      runWithoutScrollJump(function () {
        setMainFromValues(values);
      });

      Array.prototype.forEach.call(packIdSelects, function (otherSelect) {
        if (otherSelect === changedPackSelect) return;
        var match = Array.prototype.find.call(otherSelect.options, function (opt) {
          return opt.textContent.trim() === selectedText;
        });
        if (match && otherSelect.value !== match.value) {
          otherSelect.value = match.value;
          triggerVariantEvents(otherSelect);
        }
      });
    }

    var mainControls = [];
    for (var pos = 1; pos <= 3; pos++) {
      var ctrl = getMainControl(pos);
      if (!ctrl) break;

      if (ctrl.type === 'select') {
        mainControls.push(ctrl.el);
      } else {
        Array.prototype.forEach.call(ctrl.els, function (r) { mainControls.push(r); });
      }
    }

    if (!mainControls.length) return;

    mainControls.forEach(function (el) {
      el.addEventListener('change', function () {
        if (isSyncing) return;
        isSyncing = true;
        syncPackFromMain();
        isSyncing = false;
      });
    });

    Array.prototype.forEach.call(packIdSelects, function (select) {
      select.addEventListener('change', function (e) {
        if (isSyncing) return;
        isSyncing = true;
        syncMainFromPack(e.target);
        isSyncing = false;
      });
    });

    isSyncing = true;
    syncPackFromMain();
    isSyncing = false;
  }

  function initPromoCountdown(sectionEl) {
    var daysEl = sectionEl.querySelector('#custom-promo-days-wrapper');
    var hrsEl = sectionEl.querySelector('#custom-promo-hours');
    var minsEl = sectionEl.querySelector('#custom-promo-minutes');
    var secsEl = sectionEl.querySelector('#custom-promo-seconds');

    if (!daysEl || !hrsEl || daysEl.dataset.idmPromoInit === '1') return;
    daysEl.dataset.idmPromoInit = '1';

    if (!window.IDM_PROMO_COUNTDOWN || typeof window.IDM_PROMO_COUNTDOWN.getNextDeadline !== 'function') {
      return;
    }

    var locale = window.IDM_PROMO_COUNTDOWN.getCurrentLocale();
    var countdownData = window.IDM_PROMO_COUNTDOWN.getNextDeadline(locale);
    var deadline = countdownData.deadlineMs;
    var isEN = countdownData.locale.indexOf('en') === 0;

    function pad2(n) {
      return n < 10 ? '0' + n : String(n);
    }

    var prevDayLabel = null;

    function updateCountdown() {
      var diff = deadline - Date.now();

      if (diff <= 0) {
        var _pb = sectionEl.querySelector('.custom-promo-block');
        if (_pb && _pb.style.display === 'none') {
          deadline = window.IDM_PROMO_COUNTDOWN.getNextDeadline(locale).deadlineMs;
          diff = deadline - Date.now();
        } else {
          window.location.reload();
          return;
        }
      }

      var d = Math.floor(diff / 86400000);
      var rem = diff % 86400000;
      var h = Math.floor(rem / 3600000);
      rem %= 3600000;
      var m = Math.floor(rem / 60000);
      rem %= 60000;
      var s = Math.floor(rem / 1000);

      var newDayLabel = d > 0
        ? d + (isEN ? (d === 1 ? ' day and ' : ' days and ') : (d === 1 ? ' jour et ' : ' jours et '))
        : '';

      if (newDayLabel !== prevDayLabel) {
        daysEl.textContent = newDayLabel;
        prevDayLabel = newDayLabel;
      }

      var hh = pad2(h);
      var mm = pad2(m);
      var ss = pad2(s);

      if (hrsEl.textContent !== hh) hrsEl.textContent = hh;
      if (minsEl.textContent !== mm) minsEl.textContent = mm;
      if (secsEl.textContent !== ss) secsEl.textContent = ss;
    }

    updateCountdown();
    var _tw = sectionEl.querySelector('.custom-promo-timer-wrapper');
    if (_tw) _tw.style.visibility = 'visible';
    setInterval(updateCountdown, 1000);
  }

  function initPromoVariantSync(sectionEl) {
    var details = sectionEl.querySelector('.product-details.product-single');
    if (!details || details.__idmPromoSync) return;
    var block = sectionEl.querySelector('.custom-promo-block');
    var tag = sectionEl.querySelector('.tags-promo[data-idm-promo-tag]');
    if (!block && !tag) return;
    details.__idmPromoSync = true;

    function findVariant(id) {
      var list = Array.isArray(window.variantsData) ? window.variantsData : [];
      for (var i = 0; i < list.length; i++) {
        if (list[i] && String(list[i].id) === String(id)) return list[i];
      }
      return null;
    }

    function apply() {
      var v = findVariant(details.getAttribute('data-id'));
      if (!v) return;
      var c = Number(v.compare_at_price) || 0;
      var p = Number(v.price) || 0;
      var on = c > p;
      var disp = on ? '' : 'none';
      if (block && block.style.display !== disp) block.style.display = disp;
      if (tag) {
        if (on && tag.hasAttribute('data-idm-promo-pct')) {
          var pct = '- ' + Math.floor((c - p) * 100 / c) + '%';
          if (tag.textContent !== pct) tag.textContent = pct;
        }
        if (tag.style.display !== disp) tag.style.display = disp;
      }
    }

    apply();
    new MutationObserver(apply).observe(details, { attributes: true, attributeFilter: ['data-id'] });
  }

  function initGiftcardObfuscation() {
    if (document.documentElement.dataset.idmGiftcardObfInit === '1') return;
    document.documentElement.dataset.idmGiftcardObfInit = '1';

    var el = document.getElementById('giftcard-obf');
    if (!el) return;

    function decodeB64(b64) {
      if (!b64) return '';
      try {
        return atob(b64);
      } catch (e) {
        try {
          return atob(b64.replace(/-/g, '+').replace(/_/g, '/'));
        } catch (e2) {
          return '';
        }
      }
    }

    var url = decodeB64(el.getAttribute('data-ob-direction'));
    if (!url) return;

    function go(newTab) {
      if (newTab) window.open(url, '_blank', 'noopener');
      else window.location.assign(url);
    }

    el.addEventListener('click', function (e) {
      go(e.ctrlKey || e.metaKey);
    });

    el.addEventListener('auxclick', function (e) {
      if (e.button === 1) {
        e.preventDefault();
        go(true);
      }
    });

    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        go(false);
      }
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    initMediaCounter(sectionEl);
    initKlarnaBadge(sectionEl);
    initPromoCountdown(sectionEl);
    initPromoVariantSync(sectionEl);
  }

  ready(function () {
    qsa(document, '.shopify-section.product-main, [data-section-type="product"]').forEach(initSection);
    initVariantPackSync();
    initGiftcardObfuscation();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target || document);
  });
})();


(function(){
  if (window.__FAST_UPSELL_V245__) return;
  window.__FAST_UPSELL_V245__ = true;
  const $ = s => document.querySelector(s);
  const STATE = {
    pageOnce: false,
    refused: false,
    accepted: false,
    imgSrc: "",
    lastUpsellClick: 0,
    upsellLocks: new Map(),
  };
  function freqGetBag(){
    try { return (sessionStorage.getItem("upsellDisplayed") && JSON.parse(sessionStorage.getItem("upsellDisplayed"))) || []; }
    catch(_){ return []; }
  }
  function freqSetBag(arr){
    try { sessionStorage.setItem("upsellDisplayed", JSON.stringify(arr)); } catch(_){}
  }
  function freqKeys(u){
    const out = [];
    try{
      if (u && (u.popup_id != null)) out.push(`p:${String(u.popup_id)}`);
      if (u && (u.id != null))      out.push(`i:${String(u.id)}`);
    }catch(_){}
    return Array.from(new Set(out));
  }
  function freqWasShown(u){
    if(!isShowOnceEnabled()) return false;
    const keys = freqKeys(u);
    if (!keys.length) return false;
    const bag = new Set(freqGetBag().map(String));
    return keys.some(k => bag.has(k));
  }
  function freqMarkShown(u){
    if(!isShowOnceEnabled()) return;
    const bag = new Set(freqGetBag().map(String));
    const keys = freqKeys(u);
    keys.forEach(k => bag.add(k));
    freqSetBag([...bag]);
  }
  function decodeHtml(str){ if(!str) return ""; const d=document.createElement("div"); d.innerHTML=str; return d.textContent||d.innerText||""; }
  function readHeader(){
    const g=window.__UPSELL_HEADER__;
    if(g&&(g.title||g.text)){ const title=decodeHtml(g.title||""), text=decodeHtml(g.text||""); return {title,text}; }
    return {title:"",text:""};
  }
  function applyHeader(header,{force=false}={}){ const r=$(".modal-upsell"); if(!r) return; const t1=r.querySelector(".upsell-top-title"), t2=r.querySelector(".upsell-top-text");
    if(t1&&(force||!t1.textContent.trim())) t1.textContent=header.title||"";
    if(t2&&(force||!t2.textContent.trim())) t2.textContent=header.text||"";
  }
  function langPrefix(){ try{const r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/"; return r.endsWith("/")?r:r+"/";}catch(_){return "/"} }
  function productHandleFromUrl(u){ try{const url=new URL(u,location.origin); const m=url.pathname.match(/\/products\/([^\/?#]+)/i); return m?decodeURIComponent(m[1]):null;}catch(_){return null} }
  async function fetchProductJSONByHandle(h){ const roots=Array.from(new Set([langPrefix(),"/"])); let last=null; for(const root of roots){ try{const res=await fetch(`${root}products/${encodeURIComponent(h)}.js`,{credentials:"same-origin",cache:"no-store"}); if(!res.ok){ last=new Error(`HTTP ${res.status}`); continue; } return await res.json(); }catch(e){ last=e; } } throw last||new Error("fetchProductJSON failed"); }
function getUpsellVariantFilters() {
  var cfg = window.__IDM_UPSELL_VARIANT_RULES__ || {};
  return {
    isEnglish: !!cfg.isEnglish,
    hideInEnglish: Array.isArray(cfg.hideInEnglish) ? cfg.hideInEnglish : [],
    englishOnly: Array.isArray(cfg.englishOnly) ? cfg.englishOnly : []
  };
}

function shouldHideUpsellVariant(productId, variantId) {
  var cfg = getUpsellVariantFilters();
  productId = Number(productId || 0);
  variantId = Number(variantId || 0);

  if (cfg.isEnglish) {
    return cfg.hideInEnglish.some(function (rule) {
      return Number(rule.productId) === productId && Number(rule.variantId) === variantId;
    });
  }

  return cfg.englishOnly.some(function (rule) {
    return Number(rule.productId) === productId && Number(rule.variantId) === variantId;
  });
}

function filterUpsellProductVariants(productId, variants) {
  var list = Array.isArray(variants) ? variants.slice() : [];

  return list.filter(function (variant) {
    return !shouldHideUpsellVariant(productId, variant.id);
  });
}
function buildUpsellFromProductJSON(p){
  var rawVariants = filterUpsellProductVariants(p && p.id, (p && p.variants) || []);
  if (!rawVariants.length) return null;

  const firstAvail = rawVariants.find(v => v.available) || rawVariants[0] || {};

  return {
    id: p.id,
    product_id: p.id,
    title: p.title || "",
    image: (p.images && p.images[0]) || "",
    alt: p.title || "",
    top_title: "",
    top_text: "",
    first_available_price: Number(firstAvail && firstAvail.price || 0),
    first_available_compare: Number(firstAvail && (firstAvail.compare_at_price || 0) || 0),
    variants: rawVariants.map(v => ({
      id: v.id,
      title: v.title,
      policy: v.inventory_policy || "continue",
      quantity: Number(v.inventory_quantity || 0),
      price: Number(v.price || 0),
      compare: Number(v.compare_at_price || 0),
      available: !!v.available
    }))
  };
}
  function upsellFromAllUpsells(original){
    try{ return (window.all_upsells||[]).flat().find(u=>Number(u.product_id)===Number(original))||null; }catch(_){ return null }
  }
  function upsellByVariantId(vid){
    try{
      const all=(window.all_upsells||[]).flat();
      for(const u of all){ if(Array.isArray(u.variants)&&u.variants.some(v=>String(v.id)===String(vid))) return u; }
    }catch(_){}
    return null;
  }
  function updatePriceFromSelect(select){
    const root=$(".modal-upsell"); if(!root||!select) return;
    const opt=select.options&&select.options[select.selectedIndex]; if(!opt) return;
    const price=Number(opt.dataset.price||0), compare=Number(opt.dataset.compare||0);
    const pc=root.querySelector(".product-current-price"), po=root.querySelector(".product-old-price"), pr=root.querySelector(".product-price-reduction");
    if(pc&&typeof window.formatPrice==="function") pc.textContent=formatPrice(price);
    if(po&&typeof window.formatPrice==="function") po.textContent=compare>price?formatPrice(compare):"";
    if(pr&&typeof window.formatPromo==="function") pr.textContent=formatPromo(price,compare);
  }
  function isShowOnceEnabled(){ return String( ($(".modal-upsell-content")||{}).dataset.upsellOnce )==="true"; }
  function wasShownOnce(u){ return freqWasShown(u); }
  function markShown(u){
    STATE.pageOnce = true;
    window.__FAST_UPSELL_PAGE_ONCE__ = true;
    if(isShowOnceEnabled()){
      if(typeof window.addUpsellDisplayed==="function"){ try{ window.addUpsellDisplayed(u.id); }catch(_){  } }
      freqMarkShown(u);
    }
  }
  function guardModalImage(){
    const root = $(".modal-upsell");
    if (!root || root.__imgGuard) return;
    const img = root.querySelector(".image-complete-picture");
    if (img && img.src) { STATE.imgSrc = img.src; root.dataset.fastUpsellImg = img.src; }
    const mo = new MutationObserver(() => {
      const img2 = root.querySelector(".image-complete-picture");
      const wanted = root.dataset.fastUpsellImg || STATE.imgSrc;
      if (img2 && wanted && (!img2.src || img2.src === location.href || img2.src === "")) {
        img2.src = wanted;
        setTimeout(()=>{ root.dataset.fastUpsellImg = img2.src; STATE.imgSrc = img2.src; },0);
      }
    });
    mo.observe(root, { subtree:true, attributes:true, attributeFilter:["src"], childList:true });
    root.__imgGuard = true;
  }
  function openNowWithSkeleton(header){
    const root=$(".modal-upsell");
    if(root){
      if(header&&(header.title||header.text)) applyHeader(header,{force:true});
      if(!root.querySelector(".upsell-product-name")?.textContent){ const pn=root.querySelector(".upsell-product-name"); if(pn) pn.textContent="…"; }
      if(!root.querySelector(".product-current-price")?.textContent){ const pc=root.querySelector(".product-current-price"); if(pc) pc.textContent=" "; }
      const img=root.querySelector(".image-complete-picture"); if(img&&!img.src){ img.removeAttribute("src"); img.alt=""; }
    }
    document.body.classList.add("fade-upsell");
    guardModalImage();
  }
function bindCloseHandlers(root){
  if (!root) return;
  const openDrawer = () => {
    if (typeof window.openDrawerFastFromAddResponse === "function") { try{ window.openDrawerFastFromAddResponse(); return; }catch(_){} }
    if (typeof window.updatePanierLateral === "function") { try{ window.updatePanierLateral(); return; }catch(_){} }
  };
  const closeNativeOrFallback = () => {
    if (typeof window.closeUpsellPopup === "function") {
      try{ window.closeUpsellPopup(); }
      catch(_){ document.body.classList.remove("fade-upsell"); }
    } else {
      document.body.classList.remove("fade-upsell");
    }
  };
  const closeBtn = $("#close-upsell-bar");
  if (closeBtn && !closeBtn.__fastClose){
    closeBtn.addEventListener("click", ()=>{ STATE.refused = true; closeNativeOrFallback(); });
    closeBtn.__fastClose = true;
  }
  if (!root.__fastBackdrop){
    root.addEventListener("click", e=>{ if(e.target===root){ STATE.refused = true; closeNativeOrFallback(); }});
    root.__fastBackdrop = true;
  }
  if (!document.__fastUpsellEsc){
    document.addEventListener("keydown", e=>{ if(e.key==="Escape"){ STATE.refused = true; closeNativeOrFallback(); }});
    document.__fastUpsellEsc = true;
  }
}
  function bindUpsellButton(root){
    if (!root) return;
    const btn = root.querySelector(".product-to-cart");
    if (!btn || btn.__fastBound245) return;
    btn.addEventListener("click", function(ev){
      const now = Date.now();
      if (now - STATE.lastUpsellClick < 700) { ev.preventDefault(); ev.stopImmediatePropagation(); return false; }
      STATE.lastUpsellClick = now;
      ev.preventDefault(); ev.stopImmediatePropagation();
      const sel = root.querySelector(".product-option-list");
      const vid = sel && sel.value;
      if (!vid) return false;
      const lock = STATE.upsellLocks.get(String(vid));
      if (lock && (now - lock) < 2000) return false;
      STATE.upsellLocks.set(String(vid), now);
      if (typeof window.addUpsellToCart === "function") {
        try {
          STATE.accepted = true;
          window.addUpsellToCart(ev);
          return false;
        } catch(_){}
      }
      return false;
    }, true);
    btn.__fastBound245 = true;
  }
  function prefillModal(u, header){
    const root=$(".modal-upsell"); if(!root||!u) return;
    const img=root.querySelector(".image-complete-picture");
    if(img){
      try{const l=document.createElement("link"); l.rel="preload"; l.as="image"; l.href=u.image; l.setAttribute("fetchpriority","high"); document.head.appendChild(l);}catch(_){}
      img.loading="eager"; img.decoding="async"; img.setAttribute("fetchpriority","high");
      if(u.image) img.src=u.image; img.alt=u.alt||"";
    }
    const t1=root.querySelector(".upsell-top-title"), t2=root.querySelector(".upsell-top-text"), pn=root.querySelector(".upsell-product-name");
    const topTitle=(header&&header.title)||u.top_title||"", topText=(header&&header.text)||u.top_text||"";
    if(t1) t1.textContent=topTitle; if(t2) t2.textContent=topText; if(pn) pn.textContent=u.title||"";
    const select=root.querySelector(".product-option-list"); let defaultVid=null;
    if(select){
      select.innerHTML="";
      if(u.variants&&u.variants[0]&&u.variants[0].hasOwnProperty("title")){
        select.parentNode.classList.remove("hide"); select.dataset.product_id=u.product_id;
        u.variants.forEach(v=>{ const o=document.createElement("option"); o.value=v.id; o.textContent=v.title; o.dataset.policy=v.policy; o.dataset.qty=v.quantity; o.dataset.price=v.price; o.dataset.compare=v.compare; select.appendChild(o); });
        const firstAvail=u.variants.find(v=> (v.policy!=="deny" || (v.policy==="deny" && Number(v.quantity)>0)))||u.variants[0];
        defaultVid=firstAvail?String(firstAvail.id):null;
        if(defaultVid){ select.value=defaultVid; } else { select.selectedIndex=0; defaultVid=select.options[0]?String(select.options[0].value):null; }
      }else{
        select.parentNode.classList.add("hide");
        const v=(u.variants&&u.variants[0])||{id:u.product_id,policy:"continue",quantity:0,price:u.first_available_price||0,compare:u.first_available_compare||0};
        const o=document.createElement("option"); o.value=v.id; o.dataset.policy=v.policy; o.dataset.qty=v.quantity; o.dataset.price=v.price; o.dataset.compare=v.compare; select.appendChild(o); defaultVid=String(v.id); select.value=defaultVid;
      }
      if(!select.__fastbound){
        select.addEventListener("change", function(ev){ if(typeof window.updateUpSell==="function") window.updateUpSell(ev); else updatePriceFromSelect(select); });
        select.__fastbound=true;
      }
      if(typeof window.updateUpSell==="function") window.updateUpSell({target:select}); else updatePriceFromSelect(select);
    }else{
      const pc=root.querySelector(".product-current-price"), po=root.querySelector(".product-old-price"), pr=root.querySelector(".product-price-reduction");
      if(pc&&typeof window.formatPrice==="function") pc.textContent=formatPrice(u.first_available_price||0);
      if(po&&typeof window.formatPrice==="function") po.textContent=(u.first_available_compare>u.first_available_price)?formatPrice(u.first_available_compare):"";
      if(pr&&typeof window.formatPromo==="function") pr.textContent=formatPromo(u.first_available_price||0,u.first_available_compare||0);
    }
    guardModalImage();
    bindUpsellButton(root);
    bindCloseHandlers(root);
  }
  (function wrapDisplayUpsell(){
    if(typeof window.displayUpsell!=="function" || window.displayUpsell.__wrapped_v245) return;
    const orig = window.displayUpsell;
    window.displayUpsell = function(vid){
      const alreadyOpen = document.body.classList.contains("fade-upsell");
      const u = upsellByVariantId(vid);
      const forbidPage = STATE.pageOnce || !!window.__FAST_UPSELL_PAGE_ONCE__;
      const forbidSession = u && wasShownOnce(u);
      const forbidRefused = STATE.refused || STATE.accepted;
      if (alreadyOpen || forbidPage || forbidSession || forbidRefused){
        if (u && !forbidSession) markShown(u);
        window.__DEFER_CART_OPEN__ = false;
        window.__IDM_UPSELL_DONE__ = true;
        setTimeout(function(){
          if(!document.body.classList.contains("fade-upsell")){
            try{
              if(document.body.classList.contains("slide-cart")){
                if(typeof window.updatePanierLateral==="function")window.updatePanierLateral();
              } else {
                if(typeof window.affichePanier==="function")window.affichePanier();
              }
            }catch(_){}
          }
        },100);
        return;
      }
      if(u) markShown(u); else { STATE.pageOnce = true; window.__FAST_UPSELL_PAGE_ONCE__ = true; }
      return orig.apply(this, arguments);
    };
    window.displayUpsell.__wrapped_v245 = true;
  })();
  function drawerIsBlocked(){
    return document.body.classList.contains("fade-upsell") && !(STATE.accepted || STATE.refused);
  }
  (function guardDrawerOpeners(){
    const NAMES = ["openDrawerFastFromAddResponse","updatePanierLateral","openCartDrawer","openDrawer"];
    const tryWrap = (name)=>{
      const fn = window[name];
      if (typeof fn === "function" && !fn.__fastGuard245){
        window[name] = function(){
          if (drawerIsBlocked()){ return; }
          return fn.apply(this, arguments);
        };
        window[name].__fastGuard245 = true;
      }
    };
    NAMES.forEach(tryWrap);
    const iv = setInterval(()=>{ NAMES.forEach(tryWrap); }, 200);
    setTimeout(()=>clearInterval(iv), 6000);
  })();
  window.__FAST_UPSELL_PAGE_ONCE__ = window.__FAST_UPSELL_PAGE_ONCE__ || false;
  function isATCButton(node){
    if(!node) return false;
    const sel = [
      ".add-to-cart-button",
      "button[name='add']",
      ".product-form__submit",
      "[data-add-to-cart]",
      ".add-to-cart",
      "form[action*='/cart/add'] button[type='submit']"
    ].join(",");
    const btn = node.closest(sel);
    if (!btn) return false;
    if (btn.closest(".modal-upsell")) return false;
    if (btn.closest("#cart-icon")) return false;
    return btn;
  }
  document.addEventListener("click", async (ev)=>{
    const btn = isATCButton(ev.target);
    if (!btn) return;
    if (STATE.pageOnce || window.__FAST_UPSELL_PAGE_ONCE__) return;
    if (STATE.refused || STATE.accepted) return;
    const box = btn.closest(".product-details") || btn.closest("form[action*='/cart/add']") || document;
    const original = box ? Number((box.dataset && box.dataset.original) || 0) : null;
    const header = readHeader();
    let upsell = upsellFromAllUpsells(original);
    if (upsell){
      if (wasShownOnce(upsell)) return;
      openNowWithSkeleton(header);
      prefillModal(upsell, header);
      markShown(upsell);
      return;
    }
    const a = $(".modal-upsell .slider__link");
    const upsellHref = a && a.getAttribute("href");
    const handle = upsellHref ? productHandleFromUrl(upsellHref) : null;
    if (!handle) return;
    try{
      const pj = await fetchProductJSONByHandle(handle);
const built = buildUpsellFromProductJSON(pj);
if (!built) return;
if (wasShownOnce(built)) return;
openNowWithSkeleton(header);
prefillModal(built, header);
markShown(built);
    }catch(_){
    }
  }, true);
})();
(function(){
  const DEC = (window.__FAST_DECISION__ = window.__FAST_DECISION__ || {refused:false, accepted:false});
  const isOpen = () => document.body.classList.contains("fade-upsell");
  const modal = () => document.querySelector(".modal-upsell");
  let lastATC = 0;
  let drawerCooldown = 0;
  document.addEventListener("click",(e)=>{
    const btn = e.target && e.target.closest && e.target.closest(".add-to-cart-button");
    if(!btn) return;
    lastATC = Date.now();
    setTimeout(()=>{ if(Date.now() - lastATC > 5500) lastATC = 0; }, 6000);
  }, true);
  function expectingDrawer(){
    return !isOpen() && lastATC && (Date.now() - lastATC) < 4000;
  }
function openDrawerFallback(){
  if (window.__DEFER_CART_OPEN__) return;
  if (Date.now() - drawerCooldown < 1200) return;
  if (isOpen()) return;
  drawerCooldown = Date.now();

  try { if (typeof window.affichePanier === "function") { window.affichePanier(); return; } } catch(_){}
  try { if (typeof window.openDrawerFastFromAddResponse === "function") { window.openDrawerFastFromAddResponse(); return; } } catch(_){}
  try { if (typeof window.updatePanierLateral === "function") { window.updatePanierLateral(); return; } } catch(_){}
  try { if (typeof window.openCartDrawer === "function") { window.openCartDrawer(); return; } } catch(_){}
  try { if (typeof window.openDrawer === "function") { window.openDrawer(); return; } } catch(_){}
  try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch(_){}
  try {
    fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/")+"cart.js",{credentials:"same-origin"}).then(r=>r.json()).then(cart=>{
      try{ document.dispatchEvent(new CustomEvent("fast:cart",{detail:cart})); }catch(_){}
    });
  } catch(_){}
}
  document.addEventListener("click",(e)=>{
    const r = modal(); if(!r) return;
    if (e.target?.closest(".modal-upsell .product-to-cart")) { DEC.accepted = true; DEC.refused = false; }
    if (e.target?.closest("#close-upsell-bar") || e.target === r) { DEC.refused = true; DEC.accepted = false; }
  }, true);
  document.addEventListener("keydown",(e)=>{ if(e.key==="Escape" && isOpen()){ DEC.refused = true; DEC.accepted = false; }});
  function injectNoFlashCSS(){
    if (document.getElementById("fast-upsell-noflash")) return;
    const s=document.createElement("style"); s.id="fast-upsell-noflash";
    s.textContent = `
      .modal-upsell .image-wrapper{ position:relative; }
      .modal-upsell .image-wrapper::before{
        content:""; position:absolute; inset:0;
        background:var(--fast-upsell-bg) center/cover no-repeat;
        opacity:1; transition:opacity .12s linear; pointer-events:none;
      }
      .modal-upsell .image-wrapper.fast-img-loaded::before{ opacity:0; }
    `;
    document.head.appendChild(s);
  }
  injectNoFlashCSS();
  function primeNoFlash(){
    const r = modal(); if (!r) return;
    const img = r.querySelector(".image-complete-picture"); if(!img) return;
    const wrap = img.closest(".image-wrapper") || img.parentElement || r;
    const wanted = r.dataset.fastUpsellImg || img.currentSrc || img.src || "";
    if (!wanted) return;
    wrap.style.setProperty("--fast-upsell-bg", `url("${wanted}")`);
    wrap.classList.remove("fast-img-loaded");
    try {
      img.loading="eager"; img.decoding="async";
      img.classList.remove("lazyload","lazyloaded","lazysizes");
      img.setAttribute("data-skip-lazy","true");
      if (img.hasAttribute("srcset")) img.removeAttribute("srcset");
      if (img.__primeNoFlashMO) { try { img.__primeNoFlashMO.disconnect(); } catch(_){} }
      const mo = new MutationObserver(()=>{ if(!img.src || img.src===location.href) img.src=wanted; });
      img.__primeNoFlashMO = mo;
      mo.observe(img, {attributes:true, attributeFilter:["src","srcset"]});
      if (img.complete) wrap.classList.add("fast-img-loaded");
      else {
        img.addEventListener("load", ()=>wrap.classList.add("fast-img-loaded"), {once:true});
        setTimeout(()=>wrap.classList.add("fast-img-loaded"), 400);
      }
    } catch(_){}
  }
  const moOpen = new MutationObserver(()=>{
    if (isOpen()){
      if (DEC.accepted || DEC.refused) { hardClose(); return; }
      DEC.accepted = false; DEC.refused = false;
      primeNoFlash();
    }
  });
  moOpen.observe(document.body, {attributes:true, attributeFilter:["class"]});
  const moImgSwap = new MutationObserver(()=>{ if (isOpen()) primeNoFlash(); });
  moImgSwap.observe(document.querySelector('.modal-upsell')||document.body, {subtree:true, childList:true});
  function hardClose(){
    const r = modal();
    document.body.classList.remove("fade-upsell");
    if (r){ r.style.display="none"; r.setAttribute("aria-hidden","true"); }
  }
const moReopen = new MutationObserver(() => {
  if (!isOpen() || (!DEC.refused && !DEC.accepted)) return;
  hardClose();
});
  moReopen.observe(document.body, {attributes:true, attributeFilter:["class"]});
  const CANDIDATES = ["openUpsellPopup","openUpsell","showUpsell","afficheUpsell","displayUpsell"];
  function lateWrap(name){
    const guardName = "__fast_wrapped_"+name;
    const tryWrap = ()=>{
      const fn = window[name];
      if (typeof fn === "function" && !fn[guardName]){
        const w = function(){
          const gated = (DEC.refused || DEC.accepted || window.__FAST_UPSELL_PAGE_ONCE__);
          if (gated){
            if (expectingDrawer()) openDrawerFallback();
            return;
          }
          return fn.apply(this, arguments);
        };
        w[guardName] = true;
        window[name] = w;
        return true;
      }
      return false;
    };
    if (!tryWrap()){
      const iv = setInterval(()=>{ if (tryWrap()) clearInterval(iv); }, 200);
      setTimeout(()=>clearInterval(iv), 8000);
    }
  }
  CANDIDATES.forEach(lateWrap);
})();


(function () {
  if (window.__IDM_PRODUCT_MODAL_ROUTER_V2__) return;
  window.__IDM_PRODUCT_MODAL_ROUTER_V2__ = true;

  var TEXT_MODAL_SEL = '.modal-sizechart';
  var VIDEO_INFO_MODAL_SEL = '.modal-sizechart2';
  var VIDEO_INFO_BODY_OPEN_CLASS = 'fade-sizechart2';
  var VIDEO_CTA_MODAL_SEL = '.modal-sizechart3';
  var VIDEO_CTA_BODY_OPEN_CLASS = 'fade-sizechart3';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isVisible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    return (
      (s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity || '1') > 0) ||
      el.classList.contains('open') ||
      el.getAttribute('aria-hidden') === 'false'
    );
  }

  function isIOSSafari() {
    var ua = window.navigator.userAgent || '';
    var isIOS = /iP(ad|hone|od)/i.test(ua);
    var isWebKit = /WebKit/i.test(ua);
    var isOtherIOSBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
    return isIOS && isWebKit && !isOtherIOSBrowser;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function createBasicModal(options) {
    var state = {
      booted: false,
      observer: null
    };

    function attachModalObserver(modal) {
      if (!modal || modal.__idmModalObserverBound) return;
      modal.__idmModalObserverBound = true;

      var prevOpen = isVisible(modal);
      var obs = new MutationObserver(function () {
        var nowOpen = isVisible(modal);

        if (nowOpen && !prevOpen) {
          open(modal, false);
        } else if (!nowOpen && prevOpen) {
          close(modal, false);
        }

        prevOpen = nowOpen;
      });

      obs.observe(modal, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    function boot() {
      if (state.booted) return;
      if (!$(options.modalSelector) && !$(options.triggerSelector)) return;

      state.booted = true;
      $all(options.modalSelector).forEach(attachModalObserver);

      state.observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (!node || node.nodeType !== 1) return;

            if (node.matches && node.matches(options.modalSelector)) {
              attachModalObserver(node);
            } else {
              $all(options.modalSelector, node).forEach(attachModalObserver);
            }
          });
        });
      });

      state.observer.observe(document.body, { childList: true, subtree: true });
    }

    function ensure() {
      boot();
      return $(options.modalSelector);
    }

    function open(modal, fromPopstate) {
      if (!modal) return;

      modal.style.setProperty('display', 'flex', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('open');
      modal.dataset.historyPushed = modal.dataset.historyPushed || '0';

      if (!fromPopstate && modal.dataset.historyPushed !== '1') {
        try {
          history.pushState({ idmProductModal: options.stateKey }, '', window.location.href);
        } catch (e) {}
        modal.dataset.historyPushed = '1';
      }
    }

    function close(modal, fromPopstate) {
      if (!modal) return;

      modal.style.setProperty('display', 'none', 'important');
      modal.style.setProperty('visibility', 'hidden', 'important');
      modal.style.setProperty('opacity', '0', 'important');
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('open');

      if (!fromPopstate && modal.dataset.historyPushed === '1') {
        modal.dataset.historyPushed = '0';
        try {
          history.back();
        } catch (e) {}
      } else if (fromPopstate) {
        modal.dataset.historyPushed = '0';
      }
    }

    function getOpen() {
      var modal = $(options.modalSelector);
      return modal && isVisible(modal) ? modal : null;
    }

    return {
      boot: boot,
      ensure: ensure,
      open: open,
      close: close,
      getOpen: getOpen
    };
  }

  function createExternalVideoModal(options) {
    var IFRAME_SELECTOR =
      'iframe.js-deferred-youtube,' +
      'iframe[data-src*="youtube.com/embed"],' +
      'iframe[data-src*="youtube-nocookie.com/embed"],' +
      'iframe[src*="youtube.com/embed"],' +
      'iframe[src*="youtube-nocookie.com/embed"],' +
      'iframe[data-src*="player.vimeo.com/video"],' +
      'iframe[src*="player.vimeo.com/video"]';

    var state = {
      booted: false,
      modals: [],
      modal: null,
      extraModals: [],
      iframe: null,
      originalSrc: '',
      openScrollY: 0,
      previousScrollRestoration: null,
      historyPushed: false
    };

    function isYouTubeEmbed(url) {
      return /youtube\.com\/embed|youtube-nocookie\.com\/embed/i.test(url || '');
    }

    function isVimeoEmbed(url) {
      return /player\.vimeo\.com\/video/i.test(url || '');
    }

    function setParam(url, key, value) {
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set(key, value);
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    function sameEmbedVideo(a, b) {
      try {
        var ua = new URL(a, window.location.origin);
        var ub = new URL(b, window.location.origin);
        return ua.origin === ub.origin && ua.pathname === ub.pathname;
      } catch (e) {
        return a === b;
      }
    }

    function rememberScrollRestoration() {
      if (!('scrollRestoration' in history)) return;

      if (state.previousScrollRestoration === null) {
        try {
          state.previousScrollRestoration = history.scrollRestoration;
        } catch (e) {
          state.previousScrollRestoration = 'auto';
        }
      }

      try {
        history.scrollRestoration = 'manual';
      } catch (e) {}
    }

    function restoreScrollRestorationLater() {
      if (!('scrollRestoration' in history)) return;

      var prev = state.previousScrollRestoration === null ? 'auto' : state.previousScrollRestoration;

      setTimeout(function () {
        try {
          history.scrollRestoration = prev;
        } catch (e) {}
      }, 350);

      state.previousScrollRestoration = null;
    }

    function scheduleScrollRestore() {
      var y = state.openScrollY;
      if (typeof y !== 'number' || !isFinite(y)) {
        restoreScrollRestorationLater();
        return;
      }

      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;

      root.style.scrollBehavior = 'auto';

      function restore() {
        try {
          window.scrollTo(0, y);
        } catch (e) {}
      }

      restore();
      requestAnimationFrame(restore);
      setTimeout(restore, 40);
      setTimeout(restore, 120);
      setTimeout(function () {
        restore();
        root.style.scrollBehavior = prevBehavior || '';
        restoreScrollRestorationLater();
      }, 320);
    }

    function getModals() {
      return $all(options.modalSelector);
    }

    function getIframeFromModal(modal) {
      return modal ? modal.querySelector(IFRAME_SELECTOR) : null;
    }

    function refreshRefs() {
      state.modals = getModals();
      state.modal = state.modals.length ? state.modals[0] : null;
      state.extraModals = state.modals.length > 1 ? state.modals.slice(1) : [];
      state.iframe = getIframeFromModal(state.modal);

      if (state.iframe && !state.originalSrc) {
        state.originalSrc = state.iframe.getAttribute('data-src') || state.iframe.getAttribute('src') || '';
      }
    }

    function isOpen() {
      return document.body.classList.contains(options.bodyOpenClass);
    }

    function syncModalVisibility(opened) {
      refreshRefs();

      state.modals.forEach(function (modal, index) {
        var show = !!opened && index === 0;
        var content = modal ? modal.querySelector(options.contentSelector) : null;

        modal.setAttribute('aria-hidden', show ? 'false' : 'true');

        if (show) {
          modal.style.removeProperty('display');
          modal.style.removeProperty('visibility');
          modal.style.removeProperty('opacity');
          modal.style.removeProperty('pointer-events');

          if (content) {
            content.style.removeProperty('visibility');
            content.style.removeProperty('opacity');
            content.style.removeProperty('pointer-events');
          }
        } else {
          modal.style.setProperty('display', 'none', 'important');
          modal.style.setProperty('visibility', 'hidden', 'important');
          modal.style.setProperty('opacity', '0', 'important');
          modal.style.setProperty('pointer-events', 'none', 'important');

          if (content) {
            content.style.setProperty('visibility', 'hidden', 'important');
            content.style.setProperty('opacity', '0', 'important');
            content.style.setProperty('pointer-events', 'none', 'important');
          }
        }
      });
    }

    function buildSrc(raw, autoplay) {
      if (!raw) return '';

      var src = raw;

      if (isYouTubeEmbed(src)) {
        src = setParam(src, 'enablejsapi', '1');
        src = setParam(src, 'playsinline', '1');
        src = setParam(src, 'origin', window.location.origin);
        src = setParam(src, 'rel', '0');
        src = setParam(src, 'modestbranding', '1');
        src = setParam(src, 'controls', '1');
        src = setParam(src, 'autoplay', autoplay ? '1' : '0');
      } else if (isVimeoEmbed(src)) {
        src = setParam(src, 'autoplay', autoplay ? '1' : '0');
        src = setParam(src, 'playsinline', '1');
      }

      return src;
    }

    function playIframe(iframe) {
      if (!iframe || !iframe.contentWindow) return;

      var src = iframe.getAttribute('src') || '';

      try {
        if (isYouTubeEmbed(src)) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: 'playVideo',
            args: []
          }), '*');
        } else if (isVimeoEmbed(src)) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        }
      } catch (e) {}
    }

    function stopIframe(iframe, blankSrc) {
      if (!iframe) return;

      try {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: []
          }), '*');
        }
      } catch (e) {}

      try {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: 'stopVideo',
            args: []
          }), '*');
        }
      } catch (e) {}

      try {
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        }
      } catch (e) {}

      if (blankSrc) {
        try {
          var currentSrc = iframe.getAttribute('src') || '';
          if (currentSrc && currentSrc !== 'about:blank' && !iframe.getAttribute('data-src-original')) {
            iframe.setAttribute('data-src-original', currentSrc);
          }
          iframe.setAttribute('src', 'about:blank');
        } catch (e) {}
      }
    }

    function stopExtraModalsMedia() {
      refreshRefs();

      state.extraModals.forEach(function (modal) {
        $all('iframe', modal).forEach(function (iframe) {
          stopIframe(iframe, true);
        });

        $all('video', modal).forEach(function (video) {
          try { video.pause(); } catch (e) {}
        });
      });
    }

    function hardStopPrimaryPlayback() {
      refreshRefs();

      if (state.iframe) {
        stopIframe(state.iframe, true);
      }

      if (state.modal) {
        $all('video', state.modal).forEach(function (video) {
          try { video.pause(); } catch (e) {}
        });
      }
    }

    function ensureIframeLoadedAndPlay(explicitUrl) {
      refreshRefs();
      if (!state.iframe) return;

      var raw = explicitUrl || state.iframe.getAttribute('data-src') || state.iframe.getAttribute('data-src-original') || state.iframe.getAttribute('src') || state.originalSrc || '';
      if (!raw) return;

      state.iframe.setAttribute('data-src', raw);

      var currentSrc = state.iframe.getAttribute('src') || '';
      if (currentSrc && !sameEmbedVideo(currentSrc, raw)) {
        state.iframe.removeAttribute('src');
        currentSrc = '';
      }

      var desiredSrc = buildSrc(raw, true);
      if (!desiredSrc) return;

      if (!currentSrc) {
        state.iframe.addEventListener('load', function handleLoad() {
          try {
            state.iframe.removeEventListener('load', handleLoad);
          } catch (e) {}
          if (isOpen()) {
            playIframe(state.iframe);
          }
        }, { once: true });

        state.iframe.setAttribute('src', desiredSrc);
        return;
      }

      if (currentSrc !== desiredSrc) {
        state.iframe.addEventListener('load', function handleReload() {
          try {
            state.iframe.removeEventListener('load', handleReload);
          } catch (e) {}
          if (isOpen()) {
            playIframe(state.iframe);
          }
        }, { once: true });

        state.iframe.setAttribute('src', desiredSrc);
        return;
      }

      playIframe(state.iframe);
    }

    function boot() {
      if (state.booted) return;
      if (!getModals().length && !$(options.triggerSelector)) return;

      state.booted = true;
      refreshRefs();
      syncModalVisibility(false);
      stopExtraModalsMedia();

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
          e.preventDefault();
          close(true, false);
        }
      }, true);
    }

    function ensure() {
      boot();
      refreshRefs();
      return state.modal;
    }

    function open(pushInHistory, explicitUrl) {
      ensure();
      if (!state.modal) return;

      syncModalVisibility(true);
      stopExtraModalsMedia();

      if (!isOpen()) {
        state.openScrollY = getScrollY();
        rememberScrollRestoration();
        document.body.classList.add(options.bodyOpenClass);

        if (pushInHistory && !state.historyPushed) {
          try {
            history.pushState({ idmProductModal: options.stateKey }, '', window.location.href);
            state.historyPushed = true;
          } catch (e) {}
        }
      }

      ensureIframeLoadedAndPlay(explicitUrl);
    }

    function close(goBackInHistory, fromPopstate) {
      refreshRefs();
      if (!state.modals.length) return;

      if (!isOpen()) {
        if (!goBackInHistory) {
          state.historyPushed = false;
        }
        syncModalVisibility(false);
        stopExtraModalsMedia();

        if (isIOSSafari()) {
          scheduleScrollRestore();
        } else {
          restoreScrollRestorationLater();
        }
        return;
      }

      stopExtraModalsMedia();
      hardStopPrimaryPlayback();
      document.body.classList.remove(options.bodyOpenClass);
      syncModalVisibility(false);

      if (goBackInHistory) {
        if (state.historyPushed) {
          state.historyPushed = false;
          try {
            history.back();
          } catch (e) {}
        }
      } else {
        state.historyPushed = false;
      }

      if (isIOSSafari()) {
        scheduleScrollRestore();
      } else {
        restoreScrollRestorationLater();
      }
    }

    return {
      boot: boot,
      ensure: ensure,
      open: open,
      close: close,
      isOpen: isOpen,
      getModal: function () {
        refreshRefs();
        return state.modal;
      }
    };
  }

  function createYouTubeVideoModal(options) {
    var IFRAME_SELECTOR =
      'iframe.js-deferred-youtube,' +
      'iframe[data-src*="youtube.com/embed"],' +
      'iframe[data-src*="youtube-nocookie.com/embed"],' +
      'iframe[src*="youtube.com/embed"],' +
      'iframe[src*="youtube-nocookie.com/embed"]';

    var state = {
      historyPushed: false,
      pendingPlay: false,
      booted: false,
      modals: [],
      modal: null,
      extraModals: [],
      iframe: null,
      container: null,
      player: null,
      playerReady: false,
      resumeSeconds: 0,
      needsRebuild: false,
      apiRequested: false,
      apiCallbacks: [],
      originalIframeHTML: '',
      originalIframeId: '',
      openScrollY: 0,
      previousScrollRestoration: null,
      deferredStopTimer: null,
      deferredStopRaf: 0
    };

    function rememberScrollRestoration() {
      if (!('scrollRestoration' in history)) return;
      if (state.previousScrollRestoration === null) {
        try {
          state.previousScrollRestoration = history.scrollRestoration;
        } catch (e) {
          state.previousScrollRestoration = 'auto';
        }
      }
      try {
        history.scrollRestoration = 'manual';
      } catch (e) {}
    }

    function restoreScrollRestorationLater() {
      if (!('scrollRestoration' in history)) return;

      var prev = state.previousScrollRestoration === null ? 'auto' : state.previousScrollRestoration;

      setTimeout(function () {
        try {
          history.scrollRestoration = prev;
        } catch (e) {}
      }, 350);

      state.previousScrollRestoration = null;
    }

    function scheduleScrollRestore() {
      var y = state.openScrollY;
      if (typeof y !== 'number' || !isFinite(y)) {
        restoreScrollRestorationLater();
        return;
      }

      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';

      function restore() {
        try {
          window.scrollTo(0, y);
        } catch (e) {}
      }

      restore();
      requestAnimationFrame(restore);
      setTimeout(restore, 40);
      setTimeout(restore, 120);
      setTimeout(function () {
        restore();
        root.style.scrollBehavior = prevBehavior || '';
        restoreScrollRestorationLater();
      }, 320);
    }

    function clearDeferredStop() {
      if (state.deferredStopTimer) {
        clearTimeout(state.deferredStopTimer);
        state.deferredStopTimer = null;
      }
      if (state.deferredStopRaf) {
        cancelAnimationFrame(state.deferredStopRaf);
        state.deferredStopRaf = 0;
      }
    }

    // 19/10/2026 (INP de la croix : 250 à 370 ms de code sur iPhone, 80 à 180 ms sur Android, Clarity) : à la fermeture, le
    // démontage du lecteur YouTube (adresse about:blank puis retrait du cadre par destroy()) se faisait PENDANT le toucher. Dans
    // Safari iPhone, le cadre YouTube tourne dans le même fil que la page : toute la page YouTube est détruite avant que la fenêtre
    // disparaisse à l'écran. Désormais : son coupé tout de suite (simple message « pause » au lecteur), fenêtre masquée, puis
    // démontage APRÈS l'image suivante (requestAnimationFrame puis tâche). Une réouverture avant le démontage l'annule
    // (clearDeferredStop) et reconstruit un cadre neuf (needsRebuild).
    function couperLeSon() {
      if (state.playerReady && state.player && typeof state.player.pauseVideo === 'function') {
        try { state.player.pauseVideo(); } catch (e) {}
        return;
      }
      if (state.iframe && state.iframe.contentWindow) {
        try {
          state.iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
        } catch (e) {}
      }
    }

    function planifierArret() {
      clearDeferredStop();
      state.needsRebuild = true;
      state.deferredStopRaf = requestAnimationFrame(function () {
        state.deferredStopRaf = 0;
        state.deferredStopTimer = setTimeout(function () {
          state.deferredStopTimer = null;
          if (isOpen()) return;
          stopExtraModalsMedia();
          hardStopPrimaryPlayback();
        }, 0);
      });
    }

    function getModals() {
      return $all(options.modalSelector);
    }

    function getIframeFromModal(modal) {
      return modal ? modal.querySelector(IFRAME_SELECTOR) : null;
    }

    function refreshRefs() {
      state.modals = getModals();
      state.modal = state.modals.length ? state.modals[0] : null;
      state.extraModals = state.modals.length > 1 ? state.modals.slice(1) : [];
      state.iframe = getIframeFromModal(state.modal);
      state.container = state.iframe && state.iframe.parentNode
        ? state.iframe.parentNode
        : (state.modal ? state.modal.querySelector('.video-container') : null);

      if (state.iframe && !state.originalIframeHTML) {
        state.originalIframeHTML = state.iframe.outerHTML;
        state.originalIframeId = state.iframe.id || '';
      }
    }

    function isOpen() {
      return document.body.classList.contains(options.bodyOpenClass);
    }

    function syncModalVisibility(opened) {
      refreshRefs();

      state.modals.forEach(function (modal, index) {
        var show = !!opened && index === 0;
        var content = modal ? modal.querySelector(options.contentSelector) : null;

        modal.setAttribute('aria-hidden', show ? 'false' : 'true');

        if (show) {
          modal.style.removeProperty('display');
          modal.style.removeProperty('visibility');
          modal.style.removeProperty('opacity');
          modal.style.removeProperty('pointer-events');

          if (content) {
            content.style.removeProperty('visibility');
            content.style.removeProperty('opacity');
            content.style.removeProperty('pointer-events');
          }
        } else {
          modal.style.setProperty('display', 'none', 'important');
          modal.style.setProperty('visibility', 'hidden', 'important');
          modal.style.setProperty('opacity', '0', 'important');
          modal.style.setProperty('pointer-events', 'none', 'important');

          if (content) {
            content.style.setProperty('visibility', 'hidden', 'important');
            content.style.setProperty('opacity', '0', 'important');
            content.style.setProperty('pointer-events', 'none', 'important');
          }
        }
      });
    }

    function setParam(url, key, value) {
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set(key, value);
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    function removeParam(url, key) {
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.delete(key);
        return u.toString();
      } catch (e) {
        return url;
      }
    }

    function ensureIframeId() {
      if (!state.iframe) return '';
      if (!state.iframe.id) {
        state.iframe.id = state.originalIframeId || options.fallbackIframeId;
      }
      return state.iframe.id;
    }

    // 19/10/2026 (Clarity : la vidéo « Voir & écouter » ne démarrait que 2 fois sur 100 quand isIOSSafari() est vrai — Safari iPhone,
    // appli Google, applis iPad — contre 95 à 97 % partout ailleurs) : l'ancien « contournement iOS » chargeait la vidéo par
    // contentWindow.location.replace(src) SANS poser l'attribut src. Or l'API YouTube (www-widgetapi.js : sendMessage et host) calcule
    // l'adresse de ses messages à partir de iframe.src : src vide → messages envoyés vers l'origine '' (refusés par le navigateur) →
    // aucune poignée de main, onReady jamais reçu, playVideo jamais envoyé, et le lecteur ne dit jamais rien à la page (Clarity aveugle).
    // On pose donc TOUJOURS l'attribut src, pendant le toucher, comme les vignettes YouTube (idm-yt-facade : 94 % sur Safari iPhone).
    // Un éventuel loading="lazy" est retiré avant (chargement différé = départ hors du toucher) ; le cadre des fiches n'en a pas.
    function setIframeSrcSafely(iframe, src) {
      if (!iframe || !src) return false;

      var currentSrc = iframe.getAttribute('src') || '';
      if (currentSrc === src) return false;

      if (iframe.getAttribute('loading') === 'lazy') iframe.removeAttribute('loading');
      iframe.setAttribute('src', src);
      return false;
    }

    function getRawSrc() {
      if (!state.iframe) return '';
      return (
        state.iframe.getAttribute('data-src-original') ||
        state.iframe.getAttribute('data-src') ||
        state.iframe.getAttribute('src') ||
        ''
      );
    }

    function buildPlayerSrc(autoplay) {
      var raw = getRawSrc();
      if (!raw) return '';

      var src = raw;
      src = setParam(src, 'enablejsapi', '1');
      src = setParam(src, 'playsinline', '1');
      src = setParam(src, 'origin', window.location.origin);
      src = setParam(src, 'rel', '0');
      src = setParam(src, 'modestbranding', '1');
      src = setParam(src, 'controls', '1');
      src = setParam(src, 'autoplay', autoplay ? '1' : '0');

      if (state.resumeSeconds > 0) {
        src = setParam(src, 'start', String(Math.max(0, Math.floor(state.resumeSeconds))));
      } else {
        src = removeParam(src, 'start');
      }

      return src;
    }

    function loadYouTubeApi(callback) {
      if (window.YT && typeof window.YT.Player === 'function') {
        callback();
        return;
      }

      state.apiCallbacks.push(callback);

      if (state.apiRequested) return;
      state.apiRequested = true;

      var previousReady = window.onYouTubeIframeAPIReady;

      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === 'function') {
          try {
            previousReady();
          } catch (e) {}
        }

        var queue = state.apiCallbacks.slice(0);
        state.apiCallbacks = [];

        for (var i = 0; i < queue.length; i += 1) {
          try {
            queue[i]();
          } catch (e) {}
        }
      };

      var existingApi = document.querySelector(
        'script[src*="youtube.com/iframe_api"], script[src*="youtube.com/player_api"]'
      );

      if (existingApi) return;

      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';

      var firstScriptTag = document.getElementsByTagName('script')[0];
      if (firstScriptTag && firstScriptTag.parentNode) {
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        document.head.appendChild(tag);
      }
    }

    // 19/10/2026 : vidéo vue jusqu'au bout → la réouverture repart du DÉBUT. Avant, la position lue à la fermeture (= la durée de la
    // vidéo, lecteur à l'écran de fin) écrasait le 0 posé par onPlayerStateChange : la réouverture demandait start=<fin> et la vidéo ne
    // repartait pas (Clarity : 56 % de reprises après une vidéo vue en entier, contre 100 % après une vidéo interrompue).
    function saveCurrentTime() {
      if (!state.playerReady || !state.player || typeof state.player.getCurrentTime !== 'function') return;

      try {
        var t = state.player.getCurrentTime();
        var etat = typeof state.player.getPlayerState === 'function' ? state.player.getPlayerState() : -1;
        var duree = typeof state.player.getDuration === 'function' ? state.player.getDuration() : 0;
        if (etat === 0 || (duree > 0 && t >= duree - 2)) {
          state.resumeSeconds = 0;
        } else if (typeof t === 'number' && isFinite(t) && t > 0) {
          state.resumeSeconds = t;
        }
      } catch (e) {}
    }

    function onPlayerReady() {
      state.playerReady = true;

      if (state.resumeSeconds > 0 && state.player && typeof state.player.seekTo === 'function') {
        try {
          state.player.seekTo(state.resumeSeconds, true);
        } catch (e) {}
      }

      if (state.pendingPlay && isOpen() && state.player && typeof state.player.playVideo === 'function') {
        try {
          state.player.playVideo();
        } catch (e) {}
      }

      state.pendingPlay = false;
    }

    function onPlayerStateChange(event) {
      if (!event) return;
      if (event.data === 0) {
        state.resumeSeconds = 0;
      }
    }

    function onAutoplayBlocked() {
      state.pendingPlay = false;
    }

    function stopIframePlayback(iframe, blankSrc) {
      if (!iframe) return;

      try {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: []
        }), '*');
      } catch (e) {}

      try {
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: 'stopVideo',
          args: []
        }), '*');
      } catch (e) {}

      if (blankSrc) {
        try {
          var currentSrc = iframe.getAttribute('src') || '';
          if (currentSrc && currentSrc !== 'about:blank' && !iframe.getAttribute('data-src-original')) {
            iframe.setAttribute('data-src-original', currentSrc);
          }
          iframe.setAttribute('src', 'about:blank');
        } catch (e) {}
      }
    }

    function stopExtraModalsMedia() {
      refreshRefs();
      state.extraModals.forEach(function (modal) {
        $all('iframe', modal).forEach(function (iframe) {
          stopIframePlayback(iframe, true);
        });
      });
    }

    function hardStopPrimaryPlayback() {
      refreshRefs();

      if (state.playerReady && state.player && typeof state.player.pauseVideo === 'function') {
        try {
          state.player.pauseVideo();
        } catch (e) {}
      }

      if (state.playerReady && state.player && typeof state.player.stopVideo === 'function') {
        try {
          state.player.stopVideo();
        } catch (e) {}
      }

      if (state.iframe) {
        stopIframePlayback(state.iframe, true);
      }

      if (state.player && typeof state.player.destroy === 'function') {
        try {
          state.player.destroy();
        } catch (e) {}
      }

      state.player = null;
      state.playerReady = false;
      state.needsRebuild = true;
    }

    function mountYouTubePlayer() {
      refreshRefs();
      if (!state.iframe) return;

      ensureIframeId();

      if (state.player && state.player.getIframe) {
        try {
          var currentIframe = state.player.getIframe();

          if (currentIframe && currentIframe.id === state.iframe.id) {
            if (state.playerReady && state.pendingPlay && isOpen()) {
              if (state.resumeSeconds > 0 && typeof state.player.seekTo === 'function') {
                try {
                  state.player.seekTo(state.resumeSeconds, true);
                } catch (e) {}
              }

              if (typeof state.player.playVideo === 'function') {
                try {
                  state.player.playVideo();
                } catch (e) {}
              }
            }

            state.pendingPlay = false;
            return;
          }
        } catch (e) {}
      }

      state.playerReady = false;

      try {
        state.player = new window.YT.Player(state.iframe.id, {
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
            onAutoplayBlocked: onAutoplayBlocked
          }
        });
      } catch (e) {}
    }

    function createPlayerOnCurrentIframe() {
      clearDeferredStop();
      refreshRefs();
      if (!state.iframe) return;

      ensureIframeId();

      var desiredSrc = buildPlayerSrc(state.pendingPlay && isOpen());
      var usedIOSFirstLoadWorkaround = false;

      if (desiredSrc) {
        usedIOSFirstLoadWorkaround = setIframeSrcSafely(state.iframe, desiredSrc);
      }

      loadYouTubeApi(function () {
        refreshRefs();
        if (!state.iframe) return;

        ensureIframeId();

        if (usedIOSFirstLoadWorkaround) {
          var iframe = state.iframe;
          var done = false;

          function bootAfterIframeLoad() {
            if (done) return;
            done = true;

            try {
              iframe.removeEventListener('load', bootAfterIframeLoad);
            } catch (e) {}

            mountYouTubePlayer();
          }

          iframe.addEventListener('load', bootAfterIframeLoad);
          setTimeout(function () {
            bootAfterIframeLoad();
          }, 350);
          return;
        }

        mountYouTubePlayer();
      });
    }

    function rebuildPrimaryIframe() {
      clearDeferredStop();
      refreshRefs();

      if (!state.modal || !state.originalIframeHTML) {
        state.needsRebuild = false;
        createPlayerOnCurrentIframe();
        return;
      }

      var container = state.container || state.modal.querySelector('.video-container');
      if (!container) {
        state.needsRebuild = false;
        createPlayerOnCurrentIframe();
        return;
      }

      if (state.player && typeof state.player.destroy === 'function') {
        try {
          state.player.destroy();
        } catch (e) {}
      }

      state.player = null;
      state.playerReady = false;
      container.innerHTML = state.originalIframeHTML;
      refreshRefs();

      if (!state.iframe) return;

      ensureIframeId();
      state.needsRebuild = false;
      createPlayerOnCurrentIframe();
    }

    function hideModalShell() {
      document.body.classList.remove(options.bodyOpenClass);
      syncModalVisibility(false);
    }

    function forceHideModalShellRepeated() {
      hideModalShell();

      requestAnimationFrame(function () {
        hideModalShell();
        requestAnimationFrame(function () {
          hideModalShell();
        });
      });

      setTimeout(hideModalShell, 0);
      setTimeout(hideModalShell, 80);
      setTimeout(hideModalShell, 180);
    }

    function boot() {
      if (state.booted) return;
      if (!getModals().length && !$(options.triggerSelector)) return;

      state.booted = true;
      refreshRefs();
      syncModalVisibility(false);
      stopExtraModalsMedia();

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) {
          e.preventDefault();
          close(true, false);
        }
      }, true);
    }

    function ensure() {
      boot();
      refreshRefs();
      return state.modal;
    }

    function open(pushInHistory) {
      ensure();
      if (!state.modal) return;

      clearDeferredStop();
      syncModalVisibility(true);
      stopExtraModalsMedia();

      if (!isOpen()) {
        state.openScrollY = getScrollY();
        rememberScrollRestoration();
        document.body.classList.add(options.bodyOpenClass);

        if (pushInHistory && !state.historyPushed) {
          try {
            history.pushState({ idmProductModal: options.stateKey }, '', window.location.href);
            state.historyPushed = true;
          } catch (e) {}
        }
      }

      state.pendingPlay = true;

      // 19/10/2026 : à la 1re ouverture aussi, un cadre NEUF dont l'adresse est posée dans la même tâche que sa création (comme à la
      // réouverture et comme les vignettes YouTube). Poser src sur le cadre vide présent depuis le chargement de la page ajoute, dans
      // Safari (WebKit), une entrée à l'historique (banc : 2 → 4 au lieu de 2 → 3) : le bouton retour du téléphone aurait dû être
      // touché deux fois pour quitter la fiche. C'est ce que l'ancien contournement iOS évitait, au prix de la poignée de main YouTube.
      var srcActuelle = state.iframe ? (state.iframe.getAttribute('src') || '') : '';
      if (state.needsRebuild || !srcActuelle || srcActuelle === 'about:blank') {
        rebuildPrimaryIframe();
        return;
      }

      createPlayerOnCurrentIframe();
    }

    function close(goBackInHistory, fromPopstate) {
      refreshRefs();
      if (!state.modals.length) return;

      if (!isOpen()) {
        if (!goBackInHistory) {
          state.historyPushed = false;
        }
        syncModalVisibility(false);
        stopExtraModalsMedia();

        if (isIOSSafari()) {
          scheduleScrollRestore();
        } else {
          restoreScrollRestorationLater();
        }
        return;
      }

      saveCurrentTime();
      state.pendingPlay = false;

      if (fromPopstate && isIOSSafari()) {
        stopExtraModalsMedia();
        forceHideModalShellRepeated();
        state.historyPushed = false;
        scheduleScrollRestore();

        clearDeferredStop();
        state.deferredStopTimer = setTimeout(function () {
          hardStopPrimaryPlayback();
          forceHideModalShellRepeated();
          state.deferredStopTimer = null;
        }, 180);

        return;
      }

      // 19/10/2026 : son coupé et fenêtre masquée pendant le toucher ; démontage du lecteur après l'image suivante (planifierArret).
      couperLeSon();
      hideModalShell();
      planifierArret();

      if (goBackInHistory) {
        if (state.historyPushed) {
          state.historyPushed = false;
          try {
            history.back();
          } catch (e) {}
        }
      } else {
        state.historyPushed = false;
      }

      if (isIOSSafari()) {
        scheduleScrollRestore();
      } else {
        restoreScrollRestorationLater();
      }
    }

    return {
      boot: boot,
      ensure: ensure,
      open: open,
      close: close,
      isOpen: isOpen,
      getModal: function () {
        refreshRefs();
        return state.modal;
      }
    };
  }

  var TextModal = createBasicModal({
    modalSelector: TEXT_MODAL_SEL,
    triggerSelector: '.product-size-guide',
    stateKey: 'sizechart'
  });

  var InfoVideoModal = createExternalVideoModal({
    modalSelector: VIDEO_INFO_MODAL_SEL,
    triggerSelector: '.product-size-guide2',
    contentSelector: '.modal-sizechart2-content',
    bodyOpenClass: VIDEO_INFO_BODY_OPEN_CLASS,
    stateKey: 'sizechart2'
  });

  var CtaVideoModal = createYouTubeVideoModal({
    modalSelector: VIDEO_CTA_MODAL_SEL,
    triggerSelector: '.product-size-guide3',
    contentSelector: '.modal-sizechart3-content',
    bodyOpenClass: VIDEO_CTA_BODY_OPEN_CLASS,
    stateKey: 'sizechart3',
    fallbackIframeId: 'idm-sizechart3-video'
  });

  function bootAll() {
    TextModal.boot();
    InfoVideoModal.boot();
    CtaVideoModal.boot();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button;
    var modal;
    var clickedUrl;

    button = target.closest('.product-size-guide');
    if (button) {
      event.preventDefault();
      modal = TextModal.ensure();
      TextModal.open(modal, false);
      return;
    }

    button = target.closest('#close-sizechart-bar');
    if (button) {
      modal = button.closest(TEXT_MODAL_SEL) || TextModal.ensure();
      TextModal.close(modal, false);
      return;
    }

    modal = TextModal.getOpen();
    if (modal && target === modal) {
      event.preventDefault();
      TextModal.close(modal, false);
      return;
    }

    button = target.closest('.product-size-guide2, .product-size-guide2 a[href^="#promo"]');
    if (button) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      event.stopPropagation();

      clickedUrl = button.getAttribute('data-video-url') || '';
      InfoVideoModal.open(true, clickedUrl);
      return;
    }

    button = target.closest('#close-sizechart-bar2');
    if (button) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      event.stopPropagation();

      InfoVideoModal.close(true, false);
      return;
    }

    modal = InfoVideoModal.getModal();
    if (modal && target === modal && InfoVideoModal.isOpen()) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      event.stopPropagation();

      InfoVideoModal.close(true, false);
      return;
    }

    button = target.closest('.product-size-guide3');
if (button) {
  event.preventDefault();
  if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  event.stopPropagation();

  CtaVideoModal.open(true);
  return;
}

button = target.closest('#close-sizechart-bar3');
if (button) {
  event.preventDefault();
  if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  event.stopPropagation();

  CtaVideoModal.close(true, false);
  return;
}

modal = CtaVideoModal.getModal();
if (modal && target === modal && CtaVideoModal.isOpen()) {
  event.preventDefault();
  if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  event.stopPropagation();

  CtaVideoModal.close(true, false);
  return;
}
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    if (CtaVideoModal.isOpen()) {
      CtaVideoModal.close(true, false);
      return;
    }

    if (InfoVideoModal.isOpen()) {
      InfoVideoModal.close(true, false);
      return;
    }

    var openText = TextModal.getOpen();
    if (openText) {
      TextModal.close(openText, false);
    }
  }, true);

  window.addEventListener('popstate', function () {
    if (CtaVideoModal.isOpen()) {
      CtaVideoModal.close(false, true);
      return;
    }

    if (InfoVideoModal.isOpen()) {
      InfoVideoModal.close(false, true);
      return;
    }

    var openText = TextModal.getOpen();
    if (openText) {
      TextModal.close(openText, true);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    function takeEarlyGuardOpen(sel) {
      var m = document.querySelector(sel);
      if (!m || !m.classList.contains('open') || m.getAttribute('aria-hidden') !== 'false') return false;
      m.classList.remove('open');
      return true;
    }

    var earlyCtaOpen = takeEarlyGuardOpen(VIDEO_CTA_MODAL_SEL);
    var earlyInfoOpen = takeEarlyGuardOpen(VIDEO_INFO_MODAL_SEL);

    bootAll();

    if (earlyCtaOpen || earlyInfoOpen) {
      setTimeout(function () {
        if (earlyCtaOpen && !CtaVideoModal.isOpen()) {
          CtaVideoModal.open(true);
        } else if (earlyInfoOpen && !InfoVideoModal.isOpen()) {
          InfoVideoModal.open(true);
        }
      }, 0);
    }

    var legacy = {
      '#popup-avis': function () {
        var modal = TextModal.ensure();
        TextModal.open(modal, true);
      },
      '#popup-infos': function () {
        InfoVideoModal.open(false);
      },
      '#idm-sizechart3': function () {
        CtaVideoModal.open(false);
      }
    };

    if (legacy[location.hash]) {
      legacy[location.hash]();

      try {
        history.replaceState(history.state, '', window.location.pathname + window.location.search);
      } catch (e) {}
    }
  });

  document.addEventListener('shopify:section:load', function () {
    bootAll();
  });
})();

(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function getBootMap() {
    return window.__IDM_PRODUCT_BOOT__ || {};
  }

  function getBootList() {
    var map = getBootMap();
    return Object.keys(map).map(function (key) {
      return map[key];
    });
  }

  function getFirstBoot() {
    var list = getBootList();
    return list.length ? list[0] : null;
  }

  function initUpsellsRender() {
    if (window.__IDMInitUpsellsRender__) return;
    window.__IDMInitUpsellsRender__ = true;

    function renderUpsells(variantId) {
      var cfg = getFirstBoot();
      if (!cfg) return;

var productTextsEl = document.querySelector('.product-texts');
var currentCurrencyCode = productTextsEl && productTextsEl.dataset.currencyCode
  ? productTextsEl.dataset.currencyCode
  : ((window.theme && window.theme.currentCurrency) ? window.theme.currentCurrency : '');

var currentCurrencySymbol = productTextsEl && productTextsEl.dataset.currency
  ? productTextsEl.dataset.currency
  : '';

var currentLocale = document.documentElement.lang || 'fr-FR';

function formatUpsellMoney(cents) {
  var value = Number(cents || 0);

  if (typeof window.formatPrice === 'function') {
    return window.formatPrice(value);
  }

  
  
  var _currencyLocaleMap = {
    'EUR':'fr-FR','USD':'en-US','CAD':'en-CA','AUD':'en-AU','GBP':'en-GB',
    'CHF':'de-CH','NOK':'nb-NO','SEK':'sv-SE','DKK':'da-DK','PLN':'pl-PL',
    'CZK':'cs-CZ','HUF':'hu-HU','RON':'ro-RO','TRY':'tr-TR','RUB':'ru-RU',
    'JPY':'ja-JP','CNY':'zh-CN','KRW':'ko-KR','BRL':'pt-BR','INR':'en-IN'
  };
  var _idmUrlLoc = '', _idmWide = false;
  try { var _m = String(location.pathname || '').match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$)/i); var _l = _m ? _m[1].toLowerCase() : ''; if (!_m && /^\/en(?:\/|$)/i.test(String(location.pathname || '')) && String(currentCurrencyCode || '').toUpperCase() === 'EUR') _idmUrlLoc = 'en-IE'; if (_l === 'en-ie') _idmUrlLoc = 'en-IE'; else if (_l === 'fr-ca') { _idmUrlLoc = 'fr'; _idmWide = true; } else if (_l === 'en-ca' || _l === 'en-au' || _l === 'en-nz') { _idmUrlLoc = 'en'; _idmWide = true; } } catch (e) {}
  var moneyLocale = _idmUrlLoc
    || ((typeof window.getFormatLocale === 'function') ? window.getFormatLocale(currentCurrencyCode)
    : ((typeof window.getCurrencyLocale === 'function') ? window.getCurrencyLocale(currentCurrencyCode)
    : (_currencyLocaleMap[String(currentCurrencyCode || '').toUpperCase()] || currentLocale)));

  if (currentCurrencyCode && window.Intl && typeof Intl.NumberFormat === 'function') {
    try {
      var frac = value % 100 === 0 ? 0 : 2;
      return new Intl.NumberFormat(moneyLocale, {
        style: 'currency',
        currency: currentCurrencyCode,
        currencyDisplay: _idmWide ? 'symbol' : 'narrowSymbol',
        minimumFractionDigits: frac,
        maximumFractionDigits: frac
      }).format(value / 100).replace(/'/g, '’').replace(/ /g, ' ');
    } catch (e) {}
  }

  var frac2 = value % 100 === 0 ? 0 : 2;
  var amount = (value / 100).toFixed(frac2);

  if (currentCurrencySymbol) {
    if (/^(fr|de|es|it|pt|nl|nb|sv|da|pl|cs|hu|ro|tr|ru|ja|zh|ko|pt)/i.test(moneyLocale)) {
      return amount + ' ' + currentCurrencySymbol;
    }
    return currentCurrencySymbol + amount;
  }

  return amount;
}

      var UPS_BADGE = cfg.upsellBadge;

      var upsells = (window.upsellByVariant && window.upsellByVariant[variantId]) || [];
      var container = document.getElementById('upsell-container');
      if (!container) return;

      if (!upsells.length) {
        container.innerHTML = '';
        container.setAttribute('data-idm-v', String(variantId));
        return;
      }

      if (container.getAttribute('data-idm-v') === String(variantId) && container.querySelector('.idm-acc-carte')) return;

      var esc = function (v) {
        return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      };
      var texte = container.getAttribute('data-idm-texte') || '';
      var totalCents = 0;
      var items = '';

      upsells.forEach(function (u) {
        totalCents += u.priceCents;
        var img = (window.__UPSELL_I18N && window.__UPSELL_I18N[u.id]) ? window.__UPSELL_I18N[u.id] : u.imgUrl;
        var lib = esc(u.productTitle) + ' – ' + esc(u.variantTitle);
        items += '<a class="var-prod idm-acc-it" href="' + u.url + '" data-vid="' + u.id + '">'
          + '<span class="idm-acc-img"><img src="' + img + '" alt="' + lib + '" loading="lazy" decoding="async" width="' + (u.imgWidth || 200) + '" height="' + (u.imgHeight || 200) + '"></span>'
          + '<span class="idm-acc-txt"><strong class="idm-acc-nom">' + u.productTitle + '</strong><span class="idm-acc-var">' + u.variantTitle + '</span></span>'
          + '<span class="idm-acc-px"><s>' + formatUpsellMoney(u.priceCents) + '</s><span class="idm-acc-off">' + UPS_BADGE + '</span></span>'
          + '</a>';
      });

      var htmlAcc = '<div class="idm-acc-carte"><p class="idm-acc-titre"><strong class="idm-acc-total">' + formatUpsellMoney(totalCents) + '</strong> ' + esc(texte) + '</p><div class="idm-acc-liste">' + items + '</div></div>';
      var modeleAcc = document.createElement('template');
      modeleAcc.innerHTML = htmlAcc;
      if (modeleAcc.innerHTML !== container.innerHTML) container.innerHTML = htmlAcc;
      container.setAttribute('data-idm-v', String(variantId));
    }

    var form = document.getElementById('ajoute-panier');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"], select[name="id"]');
    if (!variantInput) return;

    renderUpsells(variantInput.value);

    form.addEventListener('change', function () {
      setTimeout(function () {
        renderUpsells(variantInput.value);
      }, 50);
    });

    window.renderUpsells = renderUpsells;
  }

  function getCurrentSwitchValue(cfg, switchInputs, fallback) {
    var value = '';
    var inputs = switchInputs ? Array.prototype.slice.call(switchInputs) : [];

    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (!el) continue;

      if (el.tagName === 'SELECT') {
        value = String(el.value || '').trim();
        if (value) return value;
      }

      if ((el.type === 'radio' || el.type === 'checkbox') && el.checked) {
        value = String(el.value || '').trim();
        if (value) return value;
      }
    }

    if (typeof fallback === 'string') return fallback.trim();
    return String(cfg && cfg.actualSwitch ? cfg.actualSwitch : '').trim();
  }

  function getVisibleSliderItems(inner) {
    if (!inner) return [];
    return Array.prototype.filter.call(inner.querySelectorAll('.slider__item'), function (item) {
      return item.offsetParent !== null && getComputedStyle(item).display !== 'none';
    });
  }

  function markFirstVisibleActive(root) {
    var inner = root.querySelector('.slider__product .slider__inner');
    var visibleItems = getVisibleSliderItems(inner);

    Array.prototype.forEach.call(
      root.querySelectorAll('.slider__product .slider__item.active'),
      function (item) {
        item.classList.remove('active');
      }
    );

    if (visibleItems[0]) {
      visibleItems[0].classList.add('active');
    }
  }

  function destroySliderInstance(slider) {
    if (!slider) return;

    var inst = slider.__idmFSliderInstance;

    if (inst) {
      ['destroy', 'kill', 'teardown', 'unbind'].forEach(function (method) {
        if (inst && typeof inst[method] === 'function') {
          try { inst[method](); } catch (e) {}
        }
      });
    }

    slider.__idmFSliderInstance = null;

    var inner = slider.querySelector('.slider__inner');
    if (inner) {
      inner.style.transform = 'translate3d(0px, 0px, 0px)';
      inner.scrollLeft = 0;
    }

    Array.prototype.forEach.call(
      slider.querySelectorAll('.slider__previous, .slider__next'),
      function (btn) {
        btn.classList.remove('reveal');
        btn.style.pointerEvents = '';
      }
    );
  }

  function whenFSliderReady(cb) {
    var tries = 0;

    function tick() {
      if (typeof window.FSlider === 'function') {
        cb();
        return;
      }

      tries += 1;
      if (tries < 50) {
        setTimeout(tick, 120);
      }
    }

    tick();
  }

  function rebuildSlider(productMain) {
    var slider = productMain.querySelector('.slider__product');
    if (!slider) return;

    clearTimeout(slider.__idmSliderReinitTimer);

    slider.__idmSliderReinitTimer = setTimeout(function () {
      var inner = slider.querySelector('.slider__inner');
      var buttons = slider.querySelector('.slider__buttons');
      var visibleItems = getVisibleSliderItems(inner);
      var forceFirst = productMain.dataset.idmForceFirstVisible === '1';

      if (buttons) {
        var showButtons = window.matchMedia('(max-width: 799px)').matches && visibleItems.length > 1;
        buttons.style.display = showButtons ? 'flex' : 'none';
        buttons.style.visibility = showButtons ? 'visible' : 'hidden';
        buttons.style.opacity = showButtons ? '1' : '0';
      }

      destroySliderInstance(slider);

      if (forceFirst) {
        forceFirstVisibleMedia(productMain);
      } else {
        markFirstVisibleActive(productMain);
      }

      if (visibleItems.length <= 1) return;

      whenFSliderReady(function () {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            destroySliderInstance(slider);

            try {
              slider.__idmFSliderInstance = new FSlider(slider, { reset: true });
            } catch (e) {
              return;
            }

            if (forceFirst) {
              forceFirstVisibleMedia(productMain);
            } else {
              var freshInner = slider.querySelector('.slider__inner');
              if (freshInner) {
                freshInner.style.transform = 'translate3d(0px, 0px, 0px)';
                freshInner.dispatchEvent(new Event('scroll'));
                freshInner.dispatchEvent(new Event('transitionend'));
              }
            }
          });
        });
      });
    }, 0);
  }

  function forceFirstVisibleMedia(productMain) {
    var slider = productMain && productMain.querySelector('.slider__product');
    var inner = slider && slider.querySelector('.slider__inner');

    if (!slider || !inner) return;

    var visibleItems = getVisibleSliderItems(inner);

    Array.prototype.forEach.call(
      inner.querySelectorAll('.slider__item.active'),
      function (item) {
        item.classList.remove('active');
      }
    );

    if (!visibleItems.length) return;

    visibleItems[0].classList.add('active');
    inner.style.transform = 'translate3d(0px, 0px, 0px)';
    inner.scrollLeft = 0;
    inner.dataset.idmVisibleIndex = '0';

    productMain.dataset.idmForceFirstVisible = '1';

    var thumbWrap = productMain.querySelector('.slider__thumbnails');
    if (thumbWrap) {
      Array.prototype.forEach.call(
        thumbWrap.querySelectorAll('.slider__item.active'),
        function (item) {
          item.classList.remove('active');
        }
      );

      var firstThumbValue = visibleItems[0].getAttribute('data-thumb');
      var firstThumb = firstThumbValue
        ? thumbWrap.querySelector('.slider__item[data-thumb="' + firstThumbValue + '"]')
        : null;

      if (firstThumb) {
        firstThumb.classList.add('active');
        if (typeof firstThumb.scrollIntoView === 'function') {
          firstThumb.scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }
    }

    try {
      inner.dispatchEvent(new Event('scroll', { bubbles: true }));
      inner.dispatchEvent(new Event('transitionend', { bubbles: true }));
    } catch (e) {}
  }

  window.initSwitchProduct = function () {
    var cfg = getFirstBoot();
    if (!cfg) return;

    var productMain = document.querySelector('.product-main');
    if (!productMain) return;

    var productImages = productMain.querySelector('.product-images');
    if (!productImages) return;

    var switchMedias = productImages.querySelectorAll('.slider__link');
    if (!switchMedias.length) return;

    var switch2Pos = parseInt(cfg.switchOption2Position, 10) || 0;
    var hasSwitch2 = !!cfg.hasSwitchOption2 && switch2Pos > 0;
    var switchInputs2 = hasSwitch2
      ? productMain.querySelectorAll('input.product-radio[name="option' + switch2Pos + '"], select.product-option-list.select' + switch2Pos)
      : [];

function requestSmoothVariantMediaReset() {
  try {
    document.dispatchEvent(new CustomEvent('idm:product-media-filtered', {
      detail: {
        root: productMain,
        forceFirst: true,
        smooth: true
      }
    }));
  } catch (e) {}
}

function applyMediaFilter(activeValue, activeValue2) {
  activeValue = String(activeValue || '').trim();
  activeValue2 = String(activeValue2 || '').trim();

  Array.prototype.forEach.call(switchMedias, function (item) {
    var mediaValue = String(item.dataset.switch || '').trim();
    var mediaValue2 = hasSwitch2 ? String(item.dataset.switch2 || '').trim() : '';
    var mustShow = (!mediaValue || !activeValue || mediaValue === activeValue) &&
      (!mediaValue2 || !activeValue2 || mediaValue2 === activeValue2);

    if (item.classList.contains('active')) item.classList.remove('active');

    if (mustShow) {
      if (item.classList.contains('product-switch') || item.classList.contains('is-hidden-by-variant')) item.classList.remove('product-switch', 'is-hidden-by-variant');
      item.style.display = '';
      if (item.hasAttribute('aria-hidden')) item.removeAttribute('aria-hidden');
    } else {
      if (!item.classList.contains('product-switch') || !item.classList.contains('is-hidden-by-variant')) item.classList.add('product-switch', 'is-hidden-by-variant');
      item.style.display = 'none';
      if (item.getAttribute('aria-hidden') !== 'true') item.setAttribute('aria-hidden', 'true');
    }
  });

  productMain.dataset.idmForceFirstVisible = '1';
  requestSmoothVariantMediaReset();
}

    if (!cfg.hasOnlyDefaultVariant && cfg.hasSwitchOption) {
      var switchInputs = document.querySelectorAll('.switch-' + cfg.switchOptionInputClass);
      var switchmargin = Number(cfg.sectionMargin || 0);
      var header = document.querySelector('.header-box');

      if (header && header.classList.contains('fixed-nav')) {
        switchmargin += header.offsetHeight;
      }

      function currentSwitch2Value() {
        return hasSwitch2 ? getCurrentSwitchValue(cfg, switchInputs2, String(cfg.actualSwitch2 || '')) : '';
      }

      function colorSwitch(e) {
        var target = e && e.target;
        var isSwitch2 = !!(target && hasSwitch2 && Array.prototype.indexOf.call(switchInputs2, target) > -1);
        var value = target && !isSwitch2
          ? String(target.value || '').trim()
          : getCurrentSwitchValue(cfg, switchInputs);
        var value2 = isSwitch2
          ? String(target.value || '').trim()
          : currentSwitch2Value();

        applyMediaFilter(value, value2);

        if (e) {
          window.scroll(0, productMain.offsetTop - switchmargin);
        }
      }

      function bindSwitchInput(item) {
        if (!item.__idmColorSwitchBound) {
          item.addEventListener('change', colorSwitch);
          item.__idmColorSwitchBound = true;
        }

if ((item.type === 'radio' || item.type === 'checkbox') && !item.__idmRepeatSwitchBound) {
  var repeatLockTs = 0;

  var markAlreadyChecked = function () {
    item.__idmWasAlreadyChecked = !!item.checked;
  };

  function triggerRepeatSwitch() {
    var now = Date.now();
    if (now - repeatLockTs < 120) return;
    repeatLockTs = now;

    requestAnimationFrame(function () {
      colorSwitch({ target: item });
    });
  }

  item.addEventListener('pointerdown', markAlreadyChecked, true);
  item.addEventListener('mousedown', markAlreadyChecked, true);
  item.addEventListener('touchstart', markAlreadyChecked, { passive: true });

  item.addEventListener('click', function () {
    if (item.__idmWasAlreadyChecked && item.checked) {
      triggerRepeatSwitch();
    }
    item.__idmWasAlreadyChecked = false;
  }, true);

  if (item.id) {
    Array.prototype.forEach.call(
      document.querySelectorAll('label[for="' + item.id.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]'),
      function (label) {
        if (label.__idmRepeatSwitchLabelBound) return;

        label.addEventListener('pointerdown', markAlreadyChecked, true);
        label.addEventListener('mousedown', markAlreadyChecked, true);
        label.addEventListener('touchstart', markAlreadyChecked, { passive: true });

        label.addEventListener('click', function () {
          if (item.__idmWasAlreadyChecked && item.checked) {
            triggerRepeatSwitch();
          }
          item.__idmWasAlreadyChecked = false;
        }, true);

        label.__idmRepeatSwitchLabelBound = true;
      }
    );
  }

  item.__idmRepeatSwitchBound = true;
}
      }

      Array.prototype.forEach.call(switchInputs, bindSwitchInput);
      Array.prototype.forEach.call(switchInputs2, bindSwitchInput);

      applyMediaFilter(getCurrentSwitchValue(cfg, switchInputs), currentSwitch2Value());
      return;
    }

    markFirstVisibleActive(productMain);
    rebuildSlider(productMain);
  };

  function initThumbnailBindings() {
    var cfg = getFirstBoot();
    if (!cfg) return;
    if (cfg.imagesStyle !== '3') return;

    document.querySelectorAll('.slider__thumbnails .slider__item').forEach(function (e) {
      if (!e.__idmThumbBound) {
        e.addEventListener('click', window.targetThumbnail);
        e.__idmThumbBound = true;
      }
    });

    var prev = document.querySelector('.product-images .arrow-thumb-prev');
    if (prev && !prev.__idmPrevBound) {
      prev.addEventListener('click', function () {
        document.querySelector('.product-images .slider__product .slider__previous').click();
      });
      prev.__idmPrevBound = true;
    }

    var next = document.querySelector('.product-images .arrow-thumb-next');
    if (next && !next.__idmNextBound) {
      next.addEventListener('click', function () {
        document.querySelector('.product-images .slider__product .slider__next').click();
      });
      next.__idmNextBound = true;
    }

    var thumbnails = document.querySelector('.slider__thumbnails');
    if (thumbnails && !thumbnails.__idmScrollBound) {
      thumbnails.addEventListener('scroll', function () {
        var r = document.querySelector('.slider__thumbnails').scrollHeight,
          t = document.querySelector('.slider__thumbnails').scrollTop,
          l = document.querySelector('.slider__thumbnails').offsetHeight - r;

        if (l < 0) {
          if (t + l >= -1) {
            document.querySelector('.product-images .arrow-thumb-next').classList.remove('reveal');
          } else {
            document.querySelector('.product-images .arrow-thumb-next').classList.add('reveal');
          }

          document.querySelector('.product-images .arrow-thumb-prev').classList.toggle('reveal', t > 0);
        }
      }, { passive: true });

      thumbnails.__idmScrollBound = true;
    }
  }

  function createOneShot(fn) {
  var done = false;
  return function () {
    if (done) return;
    done = true;
    return fn();
  };
}

function bootOnIdleOrIntent(fn) {
  var run = createOneShot(fn);
  var idleId = 0;
  var timerId = 0;
  var events = ['pointerdown', 'touchstart', 'keydown'];

  function cleanup() {
    events.forEach(function (evt) {
      window.removeEventListener(evt, trigger, true);
    });

    if (idleId && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(idleId);
    }

    if (timerId) {
      clearTimeout(timerId);
    }
  }

  function trigger() {
    cleanup();
    run();
  }

  events.forEach(function (evt) {
    window.addEventListener(evt, trigger, {
      capture: true,
      passive: evt !== 'keydown'
    });
  });

  if ('requestIdleCallback' in window) {
    idleId = window.requestIdleCallback(trigger, { timeout: 2500 });
  } else {
    timerId = window.setTimeout(trigger, 1500);
  }

  return trigger;
}

function bootCriticalProductScripts() {
  initUpsellsRender();
  window.initSwitchProduct();
  initThumbnailBindings();
}

function bootNonCriticalProductScripts() {
}

ready(function () {
  var _criticalBooted = true;
  bootCriticalProductScripts();

  if (window.Shopify && window.Shopify.designMode) {
    bootNonCriticalProductScripts();
  } else {
    bootOnIdleOrIntent(bootNonCriticalProductScripts);
  }

  window.addEventListener('load', function () {
    if (!_criticalBooted && typeof window.initSwitchProduct === 'function') {
      window.initSwitchProduct();
    }
  }, { once: true });
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    bootCriticalProductScripts();
    bootNonCriticalProductScripts();
  });
}

})();


(function () {
  if (window.__IDM_PRODUCT_SLIDER_STABLE_V3__) return;
  window.__IDM_PRODUCT_SLIDER_STABLE_V3__ = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 800px)').matches;
  }

  function getRoots(ctx) {
    return qsa(ctx || document, '.product-main, .shopify-section.product-main, [data-section-type="product"]');
  }

  function getVisibleItems(inner) {
    if (!inner) return [];
    return qsa(inner, '.slider__item').filter(function (item) {
      return item.offsetParent !== null && getComputedStyle(item).display !== 'none';
    });
  }

  function getTranslateX(inner) {
    if (!inner) return 0;

    var tr = inner.style.transform || getComputedStyle(inner).transform || 'none';
    if (!tr || tr === 'none') return 0;

    var m3 = tr.match(/^matrix3d\((.+)\)$/);
    if (m3) {
      var v3 = m3[1].split(',');
      return Math.abs(parseFloat(v3[12]) || 0);
    }

    var m2 = tr.match(/^matrix\((.+)\)$/);
    if (m2) {
      var v2 = m2[1].split(',');
      return Math.abs(parseFloat(v2[4]) || 0);
    }

    var t3 = tr.match(/translate3d\(\s*(-?\d+(?:\.\d+)?)px/i);
    if (t3) return Math.abs(parseFloat(t3[1]) || 0);

    var tx = tr.match(/translateX\(\s*(-?\d+(?:\.\d+)?)px/i);
    if (tx) return Math.abs(parseFloat(tx[1]) || 0);

    return 0;
  }

  function getClosestIndexByTranslate(inner, items) {
    if (!inner || !items.length) return 0;

    var currentX = getTranslateX(inner);
    var bestIndex = 0;
    var bestDiff = Infinity;

    for (var i = 0; i < items.length; i++) {
      var diff = Math.abs(items[i].offsetLeft - currentX);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestIndex = i;
      }
    }

    return bestIndex;
  }

  function getCurrentIndex(root, items) {
    var slider = root.querySelector('.slider__product');
    var inner = slider && slider.querySelector('.slider__inner');

    if (!inner || !items.length) return 0;

    var byTransform = getClosestIndexByTranslate(inner, items);
    if (items[byTransform]) return byTransform;

    for (var i = 0; i < items.length; i++) {
      if (items[i].classList.contains('active')) return i;
    }

    var saved = parseInt(inner.dataset.idmVisibleIndex || '0', 10);
    if (!isNaN(saved) && saved >= 0 && saved < items.length) return saved;

    return 0;
  }

  function updateArrows(root, index, total) {
  var slider = root.querySelector('.slider__product');
  if (!slider) return;

  var prev = slider.querySelector('.slider__previous');
  var next = slider.querySelector('.slider__next');
  var buttons = slider.querySelector('.slider__buttons');

  if (!prev || !next) return;

  if (isDesktop()) {
    if (prev.classList.contains('reveal')) prev.classList.remove('reveal');
    if (next.classList.contains('reveal')) next.classList.remove('reveal');

    if (buttons) {
      buttons.style.display = 'none';
      buttons.style.visibility = 'hidden';
      buttons.style.opacity = '0';
      buttons.style.pointerEvents = 'none';
    }
    return;
  }

  if (buttons) {
    buttons.style.display = '';
    buttons.style.visibility = '';
    buttons.style.opacity = '';
    buttons.style.pointerEvents = '';
  }

  var revealPrev = total > 1 && index > 0;
  var revealNext = total > 1 && index < total - 1;
  if (prev.classList.contains('reveal') !== revealPrev) prev.classList.toggle('reveal', revealPrev);
  if (next.classList.contains('reveal') !== revealNext) next.classList.toggle('reveal', revealNext);
}

  function syncThumbs(root, activeItem) {
    var thumbWrap = root.querySelector('.slider__thumbnails');
    if (!thumbWrap || !activeItem) return;

    var thumbValue = activeItem.getAttribute('data-thumb');
    if (!thumbValue) return;

    qsa(thumbWrap, '.slider__item.active').forEach(function (el) {
      el.classList.remove('active');
    });

    var activeThumb = thumbWrap.querySelector('.slider__item[data-thumb="' + thumbValue + '"]');
    if (!activeThumb) return;

    activeThumb.classList.add('active');

    if (typeof activeThumb.scrollIntoView === 'function') {
      activeThumb.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth'
      });
    }
  }

  function notifySlider(inner) {
    if (!inner) return;

    try {
      inner.dispatchEvent(new Event('scroll', { bubbles: true }));
    } catch (e) {}

    try {
      inner.dispatchEvent(new Event('transitionend', { bubbles: true }));
    } catch (e) {}
  }

  function setTransformTransition(inner, enabled) {
    if (!inner) return;

    if (enabled) {
      inner.style.setProperty('transition', 'transform 380ms ease', 'important');
      inner.style.willChange = 'transform';
    } else {
      inner.style.setProperty('transition', 'none', 'important');
      inner.style.willChange = '';
    }
  }

    function goToIndex(root, newIndex, immediate) {
    immediate = !!immediate;

    var slider = root.querySelector('.slider__product');
    var inner = slider && slider.querySelector('.slider__inner');
    var frame = slider && (slider.querySelector('.slider__nav') || slider);

    if (!slider || !inner || !frame) return;

    var items = getVisibleItems(inner);

    qsa(inner, '.slider__item.active').forEach(function (el) {
      el.classList.remove('active');
    });

    if (!items.length) {
      setTransformTransition(inner, false);
      inner.style.transform = 'translate3d(0px, 0px, 0px)';
      inner.scrollLeft = 0;
      inner.dataset.idmVisibleIndex = '0';
      updateArrows(root, 0, 0);
      notifySlider(inner);
      requestAnimationFrame(function () {
        setTransformTransition(inner, true);
      });
      return;
    }

    if (newIndex < 0) newIndex = 0;
    if (newIndex > items.length - 1) newIndex = items.length - 1;

    var target = items[newIndex];
    target.classList.add('active');

    var maxTranslate = Math.max(0, inner.scrollWidth - frame.clientWidth);
    var targetX = Math.min(target.offsetLeft, maxTranslate);

    setTransformTransition(inner, !immediate);

    inner.style.transform = 'translate3d(-' + targetX + 'px, 0, 0)';
    inner.scrollLeft = 0;
    inner.dataset.idmVisibleIndex = String(newIndex);

    syncThumbs(root, target);
    updateArrows(root, newIndex, items.length);
    notifySlider(inner);

    if (immediate) {
      requestAnimationFrame(function () {
        setTransformTransition(inner, true);
      });
    }
  }

  function realign(root, forceFirst, immediate) {
  var slider = root.querySelector('.slider__product');
  var inner = slider && slider.querySelector('.slider__inner');
  if (!slider || !inner) return;

  var items = getVisibleItems(inner);
  if (!items.length) {
    updateArrows(root, 0, 0);
    return;
  }

  var index = forceFirst ? 0 : getCurrentIndex(root, items);
  goToIndex(root, index, immediate !== false);
}

function scheduleRealign(root, forceFirst, immediate, delay) {
  clearTimeout(root.__idmStableSliderTimer);
  root.__idmStableSliderTimer = setTimeout(function () {
    realign(root, !!forceFirst, immediate);
  }, typeof delay === 'number' ? delay : 0);
}

  function bindDesktopMouseShield(root) {
    var slider = root.querySelector('.slider__product');
    if (!slider || slider.__idmMouseShieldBound) return;

    function blockFSliderMouse(e) {
      if (!isDesktop()) return;

      if (
        e.target.closest &&
        e.target.closest('.slider__previous, .slider__next, .slider__buttons')
      ) {
        return;
      }

      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    ['mousedown', 'mouseup', 'mouseleave'].forEach(function (evt) {
      slider.addEventListener(evt, blockFSliderMouse, true);
    });

    slider.__idmMouseShieldBound = true;
  }

  function bindTouchSlider(root) {
    var slider = root.querySelector('.slider__product');
    if (!slider || slider.__idmTouchBound) return;

    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dy = 0;
    var startTranslate = 0;
    var dragging = false;
    var axis = '';

    function reset() {
      dragging = false;
      axis = '';
      dx = 0;
      dy = 0;
    }

    function onStart(e) {
  if (isDesktop()) return;

  var inner = slider.querySelector('.slider__inner');
  var items = getVisibleItems(inner);
  var t = e.touches && e.touches[0];

  if (!inner || !items.length || items.length <= 1 || !t) return;

  setTransformTransition(inner, false);

  dragging = true;
  axis = '';
  dx = 0;
  dy = 0;
  startX = t.clientX;
  startY = t.clientY;
  startTranslate = getTranslateX(inner);

  inner.style.willChange = 'transform';

  if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  else e.stopPropagation();
}

    function onMove(e) {
      if (!dragging || isDesktop()) return;

      var inner = slider.querySelector('.slider__inner');
      var items = getVisibleItems(inner);
      var frame = slider.querySelector('.slider__nav') || slider;
      var t = e.touches && e.touches[0];

      if (!inner || !items.length || !frame || !t) {
        reset();
        return;
      }

      dx = t.clientX - startX;
      dy = t.clientY - startY;

      if (!axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) {
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          else e.stopPropagation();
          return;
        }
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      else e.stopPropagation();

      if (axis !== 'x') return;

      e.preventDefault();

      var maxTranslate = Math.max(0, inner.scrollWidth - frame.clientWidth);
      var targetX = startTranslate - dx;

      if (targetX < 0) targetX = 0;
      if (targetX > maxTranslate) targetX = maxTranslate;

      setTransformTransition(inner, false);
      inner.style.transform = 'translate3d(-' + targetX + 'px, 0, 0)';
      inner.scrollLeft = 0;
      inner.dataset.idmVisibleIndex = String(getClosestIndexByTranslate(inner, items));

      updateArrows(root, getClosestIndexByTranslate(inner, items), items.length);
      notifySlider(inner);
    }

    function onEnd(e) {
      if (!dragging || isDesktop()) {
        reset();
        return;
      }

      var inner = slider.querySelector('.slider__inner');
      var items = getVisibleItems(inner);

      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      else e.stopPropagation();

      if (inner) inner.style.willChange = '';

      if (!inner || !items.length) {
        reset();
        return;
      }

      setTransformTransition(inner, true);
if (axis === 'x') {
  e.preventDefault();
  goToIndex(root, getClosestIndexByTranslate(inner, items));
} else {
  var savedIdx = parseInt(inner.dataset.idmVisibleIndex || '0', 10);
  if (isNaN(savedIdx) || savedIdx < 0 || savedIdx >= items.length) savedIdx = 0;
  goToIndex(root, savedIdx, true);
}

      reset();
    }

    slider.addEventListener('touchstart', onStart, { capture: true, passive: true });
    slider.addEventListener('touchmove', onMove, { capture: true, passive: false });
    slider.addEventListener('touchend', onEnd, { capture: true, passive: false });
    slider.addEventListener('touchcancel', onEnd, { capture: true, passive: false });

    slider.__idmTouchBound = true;
  }

  function initRoot(root) {
  if (!root) return;
  bindDesktopMouseShield(root);
  bindTouchSlider(root);
  var inner = root.querySelector('.slider__product .slider__inner');
  setTransformTransition(inner, true);
  scheduleRealign(root, true, true);
}

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.slider__product .slider__previous, .slider__product .slider__next');
    if (!btn) return;

    var root = btn.closest('.product-main, .shopify-section.product-main, [data-section-type="product"]');
    if (!root) return;

    var slider = root.querySelector('.slider__product');
    var inner = slider && slider.querySelector('.slider__inner');
    if (!inner) return;

    var items = getVisibleItems(inner);
    if (items.length <= 1) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var index = getCurrentIndex(root, items);
    index = btn.classList.contains('slider__next') ? index + 1 : index - 1;

    goToIndex(root, index);
  }, true);

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.slider__thumbnails .slider__item');
    if (!thumb) return;

    var root = thumb.closest('.product-main, .shopify-section.product-main, [data-section-type="product"]');
    if (!root) return;

    var slider = root.querySelector('.slider__product');
    var inner = slider && slider.querySelector('.slider__inner');
    if (!inner) return;

    var items = getVisibleItems(inner);
    var thumbValue = thumb.getAttribute('data-thumb');

    var targetIndex = -1;
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-thumb') === thumbValue) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex < 0) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    goToIndex(root, targetIndex);
  }, true);

  function productOptionChanged(target) {
    if (!target) return false;

    if (target.name && target.name.indexOf('option') === 0) return true;
    if (target.name === 'id') return true;

    var cls = typeof target.className === 'string' ? target.className : '';
    if (cls.indexOf('switch-') > -1) return true;
    if (cls.indexOf('product-radio') > -1) return true;
    if (cls.indexOf('product-option-list') > -1) return true;

    return false;
  }

  ready(function () {
    getRoots().forEach(initRoot);

    ['focus', 'pageshow'].forEach(function (evt) {
      window.addEventListener(evt, function () {
        getRoots().forEach(function (root) {
          var inner = root.querySelector('.slider__product .slider__inner');
          setTransformTransition(inner, true);
        });
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      getRoots().forEach(function (root) {
        var inner = root.querySelector('.slider__product .slider__inner');
        setTransformTransition(inner, true);
      });
    });

    window.addEventListener('resize', function () {
  getRoots().forEach(function (root) {
    scheduleRealign(root, false, true);
  });
});

    document.addEventListener('change', function (e) {
  if (!productOptionChanged(e.target)) return;

  getRoots().forEach(function (root) {
    scheduleRealign(root, true, false);
    setTimeout(function () {
      scheduleRealign(root, true, false);
    }, 50);
  });
}, true);

    document.addEventListener('input', function (e) {
  if (!productOptionChanged(e.target)) return;

  getRoots().forEach(function (root) {
    scheduleRealign(root, true, false);
  });
}, true);

    ['variant:change', 'product:variant-change', 'theme:variant:change'].forEach(function (evt) {
  document.addEventListener(evt, function () {
    getRoots().forEach(function (root) {
      scheduleRealign(root, true, false);
      setTimeout(function () {
        scheduleRealign(root, true, false);
      }, 50);
    });
  }, true);
});
  });

document.addEventListener('idm:product-media-filtered', function (e) {
  var root = e.detail && e.detail.root;
  if (!root) return;

  var immediate = !(e.detail && e.detail.smooth);

  scheduleRealign(root, true, immediate);
  setTimeout(function () {
    scheduleRealign(root, true, immediate);
  }, 50);
}, true);

  document.addEventListener('shopify:section:load', function (e) {
    getRoots(e.target || document).forEach(initRoot);
  });
})();

(function () {
  if (window.__IDM_UPSELL_REFUSE_DRAWER_FIX__) return;
  window.__IDM_UPSELL_REFUSE_DRAWER_FIX__ = true;

  function themeBody() {
    return document.querySelector('#body') || document.body;
  }

  function isUpsellOpen() {
    var b = themeBody();
    return !!(b && b.classList.contains('fade-upsell'));
  }

function openCartDrawerAfterUpsellRefuse() {
  if (document.body.classList.contains('slide-cart')) return;
  if (window.__DEFER_CART_OPEN__) return;

  if (typeof window.affichePanier === 'function') {
    window.affichePanier();
    return;
  }

  if (typeof window.openDrawerFastFromAddResponse === 'function') {
    window.openDrawerFastFromAddResponse();
    return;
  }

  if (typeof window.updatePanierLateral === 'function') {
    Promise.resolve(window.updatePanierLateral()).then(function () {
      document.body.classList.add('slide-cart');
    });
  }
}

  function handleUpsellRefuse() {
    if (!isUpsellOpen()) return;

    setTimeout(function () {
      if (!isUpsellOpen()) {
        window.__DEFER_CART_OPEN__ = false;
        window.__IDM_UPSELL_DONE__ = true;
        try{if(!document.body.classList.contains('slide-cart'))document.querySelectorAll("#drawcart-items-block,#drawcart-button-block,#drawcart-promo-block").forEach(function(el){el.style.visibility="hidden"});}catch(_){}
        openCartDrawerAfterUpsellRefuse();
      }
    }, 0);
  }

  document.addEventListener('click', function (e) {
    var modal = document.querySelector('.modal-upsell');
    if (!modal) return;

    if (e.target.closest('#close-upsell-bar') || e.target === modal) {
      handleUpsellRefuse();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      handleUpsellRefuse();
    }
  }, true);
})();


(function(){
  if(window.__IDM_ATC_RACE_FIX__)return;
  window.__IDM_ATC_RACE_FIX__=true;

  function attempt(){
    var origAP=window.ajoutProduit;
    var origAUS=window.ajoutUpsellSucces;
    if(typeof origAP!=="function"||typeof origAUS!=="function")return false;

    window.ajoutProduit=function(){
      var p=origAP.apply(this,arguments);
      if(p&&typeof p.then==="function"){
        window.__PENDING_ATC__=p;
        var idmFinAjout=function(){
          if(window.__PENDING_ATC__===p) window.__PENDING_ATC__=null;
        };
        p.then(idmFinAjout,idmFinAjout);
      }
      return p;
    };

    window.ajoutUpsellSucces=async function(e){
      var pending=window.__PENDING_ATC__;
      if(pending&&typeof pending.then==="function"){
        try{await pending;}catch(_){}
      }
      return origAUS.call(this,e);
    };

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function(){
  if(window.__IDM_SPIN_FIX__)return;
  window.__IDM_SPIN_FIX__=true;

  var prev=document.body.classList.contains("fade-upsell");

  var mo=new MutationObserver(function(){
    var now=document.body.classList.contains("fade-upsell");
    if(now===prev)return;

    if(!prev&&now){
      try{if(window.CartSpin&&typeof CartSpin.disarm==="function")CartSpin.disarm(true);}catch(_){}
    }

    if(prev&&!now){
      var dec=window.__FAST_DECISION__;
      var accepted=!!(dec&&dec.accepted);
      if(accepted){
        try{
          if(window.CartSpin&&typeof CartSpin.arm==="function"&&!document.body.classList.contains("slide-cart")){
            CartSpin.arm("upsell-accepted");
          }
        }catch(_){}
      }
    }

    prev=now;
  });

  mo.observe(document.body,{attributes:true,attributeFilter:["class"]});
})();


(function(){
  if(window.__IDM_CLOSE_UPSELL_FIX__)return;
  window.__IDM_CLOSE_UPSELL_FIX__=true;

  function attempt(){
    var orig=window.closeUpsellPopup;
    if(typeof orig!=="function")return false;

    window.closeUpsellPopup=function(){
      orig.apply(this,arguments);
      try{
        document.querySelectorAll(".add-to-cart-button").forEach(function(b){b.disabled=false;});
      }catch(_){}
    };

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function(){
  if(window.__IDM_ATC_ERR_FIX__)return;
  window.__IDM_ATC_ERR_FIX__=true;

  function attempt(){
    var orig=window.ajoutPanierErreur;
    if(typeof orig!=="function")return false;

    window.ajoutPanierErreur=function(e,t){
      window.__DEFER_CART_OPEN__=false;
      try{
        if(document.body.classList.contains("fade-upsell")&&typeof window.closeUpsellPopup==="function")window.closeUpsellPopup();
      }catch(_){}
      return orig.call(this,e,t);
    };

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function(){
  if(window.__IDM_PACK_ERR_FIX__)return;
  window.__IDM_PACK_ERR_FIX__=true;

  function attempt(){
    var orig=window.ajoutProduitPack;
    if(typeof orig!=="function")return false;

    window.ajoutProduitPack=async function(e){
      try{
        return await orig.call(this,e);
      }catch(err){
        try{
          document.querySelectorAll(".add-to-cart-button").forEach(function(b){b.disabled=false;});
        }catch(_){}
        console.warn("[IDM] ajoutProduitPack error:",err);
      }
    };

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function(){
  if(window.__IDM_UPDATE_OPEN_FIX__)return;
  window.__IDM_UPDATE_OPEN_FIX__=true;

  function attempt(){
    var origUP=window.updateProduit;
    var origUPOD=window.updateProduitAndOpenDrawer;
    if(typeof origUP!=="function"||typeof origUPOD!=="function")return false;

    window.updateProduit=function(e){
      var onProductPage=!!document.querySelector(".product-details.product-single");
      var drawerClosed=!document.body.classList.contains("slide-cart");
      if(onProductPage&&drawerClosed&&!window.__IDM_INSIDE_UPOD__){
        window.__IDM_INSIDE_UPOD__=true;
        var p=origUPOD.apply(this,arguments);
        if(p&&typeof p.then==="function"){
          p.finally(function(){window.__IDM_INSIDE_UPOD__=false;});
        }else{
          window.__IDM_INSIDE_UPOD__=false;
        }
        return p;
      }
      return origUP.apply(this,arguments);
    };

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function(){
  if(window.__IDM_DEFENSIVE_FIX__)return;
  window.__IDM_DEFENSIVE_FIX__=true;

  function attempt(){
    var origCCP=window.createComparePrice;
    var origWUD=window.wasUpsellDisplayed;
    var origAUD=window.addUpsellDisplayed;
    if(typeof origCCP!=="function"||typeof origWUD!=="function")return false;

    window.createComparePrice=function(e){
      try{return origCCP.call(this,e);}catch(_){return 0;}
    };

    var origCU=window.checkUpsells;
    if(typeof origCU==="function"){
      window.checkUpsells=function(e){
        if(window.__IDM_UPSELL_DONE__)return false;
        try{return origCU.call(this,e);}catch(_){return false;}
      };
    }

    window.wasUpsellDisplayed=function(e){
      try{return origWUD.call(this,e);}catch(_){return false;}
    };

    if(typeof origAUD==="function"){
      window.addUpsellDisplayed=function(e){
        try{origAUD.call(this,e);}catch(_){}
      };
    }

    var origPIU=window.ProductIsUpsell;
    if(typeof origPIU==="function"){
      window.ProductIsUpsell=function(e){
        try{return origPIU.call(this,e);}catch(_){return false;}
      };
    }

    var origIPU=window.isPanierUpsell;
    if(typeof origIPU==="function"){
      window.isPanierUpsell=function(e){
        try{return origIPU.call(this,e);}catch(_){return false;}
      };
    }

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function(){
  if(window.__IDM_VIDEO_IOS_FIX__)return;
  window.__IDM_VIDEO_IOS_FIX__=true;

  function attempt(){
    var orig=window.displayPopVideo;
    if(typeof orig!=="function")return false;

    window.displayPopVideo=function(e){
      orig.call(this,e);
      try{
        var iframe=document.querySelector(".modal-video .video");
        if(iframe) iframe.setAttribute("allow","autoplay; encrypted-media; gyroscope; picture-in-picture");
      }catch(_){}
    };

    return true;
  }

  if(!attempt()){
    var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);
  }
})();


(function () {
  var PART_VOLET = 0.5;
  var estMobile = function () { return window.matchMedia('(max-width: 799px)').matches; };
  var formulaire = function () { return document.getElementById('ajoute-panier'); };
  var choixDe = function (f) { return f ? f.querySelector('select.product-option-list:not(.hide), .product-option-image, .product-option-color') : null; };
  var vraiBouton = function () { return document.querySelector('#ajoute-panier .add-to-cart-button'); };
  var cTag = function (k, v) { try { if (typeof window.clarity === 'function') window.clarity('set', k, v); } catch (_) {} };
  var cEvt = function (n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (_) {} };

  var groupe = null, force = /[?&]idm_volet=([AB])\b/.exec(window.location.search);
  try {
    if (force) window.localStorage.setItem('IDM_AB_VOLET', force[1]);
    groupe = window.localStorage.getItem('IDM_AB_VOLET');
  } catch (_) {}
  if (force) groupe = force[1];
  if (groupe !== 'A' && groupe !== 'B') {
    groupe = Math.random() < PART_VOLET ? 'B' : 'A';
    try { window.localStorage.setItem('IDM_AB_VOLET', groupe); } catch (_) {}
  }
  if (PART_VOLET >= 1) groupe = 'B';
  else if (PART_VOLET <= 0) groupe = 'A';
  window.IDM_AB_VOLET = groupe;
  var poserEtiquette = function () { if (estMobile() && choixDe(formulaire())) cTag('idm_ab_volet', groupe); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poserEtiquette); else poserEtiquette();

  var CSS = '.idm-volet{position:fixed;inset:0;z-index:11;visibility:hidden;pointer-events:none}'
    + '.idm-volet--visible{visibility:visible}'
    + '.idm-volet--ouvert{pointer-events:auto}'
    + '.idm-volet__fond{position:absolute;inset:0;background:rgba(0,0,0,.45);opacity:0;transition:opacity .3s ease;touch-action:none}'
    + '.idm-volet--ouvert .idm-volet__fond{opacity:1;transition:opacity .45s ease}'
    + '.idm-volet__panneau{position:absolute;left:0;right:0;bottom:0;display:flex;flex-direction:column;max-height:85vh;max-height:85dvh;background-color:var(--body-bg);color:var(--body-text-color);border-radius:calc(var(--popups-radius,5) * 3px) calc(var(--popups-radius,5) * 3px) 0 0;box-shadow:0 -12px 40px rgba(0,0,0,.16);transform:translate3d(0,100%,0);transition:transform .3s cubic-bezier(.4,0,1,1);overscroll-behavior:contain}'
    + '.idm-volet--ouvert .idm-volet__panneau{transform:translate3d(0,0,0);transition:transform .5s cubic-bezier(.16,1,.3,1)}'
    + '.idm-volet__poignee{flex:none;height:22px;position:relative;touch-action:none}'
    + '.idm-volet__poignee:before{content:"";position:absolute;left:50%;top:9px;width:40px;height:4px;margin-left:-20px;border-radius:2px;background:currentColor;opacity:.2}'
    + '.idm-volet__fermer{position:absolute;top:4px;right:6px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;padding:0;margin:0;background:none;border:0;color:var(--close-cross);cursor:pointer;z-index:1;touch-action:manipulation}'
    + '.idm-volet__fermer svg{width:22px;height:22px;display:block}'
    + '.idm-volet__entete{flex:none;display:flex;align-items:center;gap:14px;padding:2px 56px 16px 20px;border-bottom:1px solid var(--separation-line);touch-action:none}'
    + '.idm-volet__vignette{flex:none;width:64px;height:64px;object-fit:cover;border-radius:calc(var(--popups-radius,5) * 1px);background-color:var(--prod-opt-bg)}'
    + '.idm-volet__vignette[hidden]{display:none}'
    + '.idm-volet__textes{min-width:0;flex:1 1 auto}'
    + '.idm-volet__titre{margin:0 0 4px;font-family:var(--title-font);font-style:var(--title-font-style);font-weight:var(--title-font-weight);letter-spacing:var(--title-ls);text-transform:var(--title-uppercase);color:var(--body-title-color);font-size:17px;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}'
    + '.idm-volet__prix{margin:0;color:var(--current-price);font-weight:700;font-size:17px;line-height:1.3}'
    + '.idm-volet__options{flex:1 1 auto;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:18px 20px 4px}'
    + '.idm-volet__pied{flex:none;padding:10px 20px calc(16px + env(safe-area-inset-bottom,0px));touch-action:manipulation}'
    + '.idm-volet__ajouter{display:block;width:100%;margin:0}'
    + '.idm-volet__ajouter[disabled]{opacity:.5;cursor:default}'
    + '@media (prefers-reduced-motion:reduce){.idm-volet__panneau,.idm-volet--ouvert .idm-volet__panneau{transform:none;opacity:0;transition:opacity .2s ease}.idm-volet--ouvert .idm-volet__panneau{opacity:1}}';

  var volet = null, panneau = null, zoneOptions = null, boutonVolet = null, prixVolet = null, vignette = null;
  var ouvert = false, place = null, deplaces = [], declencheur = null, overflowAvant = '', minuterie = 0, obs = null, rafMaj = 0, eleves = [];

  var redescendre = function () {
    for (var i = 0; i < eleves.length; i++) eleves[i][0].style.zIndex = eleves[i][1];
    eleves = [];
  };
  var elever = function (f) {
    redescendre();
    var a = f.parentElement;
    while (a && a !== document.body && a !== document.documentElement) {
      var cs = getComputedStyle(a), pd = a.parentElement ? getComputedStyle(a.parentElement).display : '';
      var zApplique = cs.position !== 'static' || /flex|grid/.test(pd);
      if (zApplique && (cs.position === 'fixed' || cs.position === 'sticky' || cs.zIndex !== 'auto')) {
        eleves.push([a, a.style.zIndex]);
        a.style.zIndex = '11';
      }
      a = a.parentElement;
    }
  };

  var prixActuel = function () {
    var p = document.getElementById('atc-sticky-price');
    var t = p ? (p.textContent || '') : '';
    if (!/\d/.test(t)) {
      var c = document.querySelector('#ajoute-panier .product-current-price') || document.querySelector('.product-main .product-current-price') || document.querySelector('.product-pricing .product-current-price');
      t = c ? (c.textContent || '') : '';
    }
    return t.replace(/\s+/g, ' ').replace(/^[\s|]+/, '').trim();
  };
  var imageActuelle = function () {
    var s = document.querySelector('.slider__product');
    if (!s) return null;
    var g = s.getBoundingClientRect().left, best = null, d = 1e9;
    var imgs = s.querySelectorAll('img.image-complete-picture');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (!im.complete || im.naturalWidth < 2) continue;
      var r = im.getBoundingClientRect();
      if (r.width < 40) continue;
      var x = Math.abs(r.left - g);
      if (x < d) { d = x; best = im; }
    }
    return best;
  };
  var etatBouton = function () {
    var vrai = vraiBouton();
    if (!vrai) return { mode: 'aucun', texte: '' };
    var p = vrai.closest('.product-buttons');
    var texte = (vrai.textContent || '').replace(/\s+/g, ' ').trim();
    if (!vrai.disabled && !vrai.classList.contains('expired-to-cart')) return { mode: 'ajout', vrai: vrai, texte: texte };
    if (vrai.classList.contains('expired-to-cart') && p && p.classList.contains('restock-alert') && !p.dataset.idmNoVariant) return { mode: 'alerte', p: p, texte: texte };
    return { mode: 'aucun', texte: texte };
  };
  var majVolet = function () {
    if (!volet) return;
    var s = etatBouton();
    if (boutonVolet.textContent !== s.texte) boutonVolet.textContent = s.texte;
    boutonVolet.disabled = s.mode === 'aucun';
    var prix = prixActuel();
    if (prixVolet.textContent !== prix) prixVolet.textContent = prix;
    var img = imageActuelle();
    if (img) {
      var src = img.currentSrc || img.src;
      if (src && vignette.getAttribute('src') !== src) vignette.setAttribute('src', src);
      vignette.hidden = false;
    }
  };
  var majPlanifiee = function () { if (!rafMaj) rafMaj = requestAnimationFrame(function () { rafMaj = 0; majVolet(); }); };

  var construire = function (f) {
    if (!document.getElementById('idm-volet-css')) {
      var st = document.createElement('style');
      st.id = 'idm-volet-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    volet = document.createElement('div');
    volet.className = 'idm-volet';
    volet.setAttribute('role', 'dialog');
    volet.setAttribute('aria-modal', 'true');
    volet.setAttribute('aria-labelledby', 'idm-volet-titre');
    volet.innerHTML = '<div class="idm-volet__fond"></div><div class="idm-volet__panneau"><div class="idm-volet__poignee"></div><button type="button" class="idm-volet__fermer"></button><div class="idm-volet__entete"><img class="idm-volet__vignette" alt="" hidden><div class="idm-volet__textes"><p class="idm-volet__titre" id="idm-volet-titre"></p><p class="idm-volet__prix"></p></div></div><div class="idm-volet__options"></div><div class="idm-volet__pied"><button type="button" class="index-button big-button idm-volet__ajouter"></button></div></div>';
    panneau = volet.querySelector('.idm-volet__panneau');
    zoneOptions = volet.querySelector('.idm-volet__options');
    boutonVolet = volet.querySelector('.idm-volet__ajouter');
    prixVolet = volet.querySelector('.idm-volet__prix');
    vignette = volet.querySelector('.idm-volet__vignette');
    var croix = volet.querySelector('.idm-volet__fermer');
    var modele = document.querySelector('.close-news-icon[aria-label]');
    croix.setAttribute('aria-label', modele ? modele.getAttribute('aria-label') : 'Fermer');
    var svg = document.querySelector('.close-news-icon svg');
    if (svg) croix.appendChild(svg.cloneNode(true));
    else croix.innerHTML = '<svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M 6 6 L 18 18 Z M 6 18 L 18 6 Z"/></svg>';
    var h1 = document.querySelector('h1.product-title') || document.querySelector('h1');
    volet.querySelector('.idm-volet__titre').textContent = h1 ? (h1.textContent || '').replace(/\s+/g, ' ').trim() : '';
    f.appendChild(volet);
    var fond = volet.querySelector('.idm-volet__fond');
    fond.addEventListener('click', function () { fermer('fond'); });
    fond.addEventListener('touchmove', function (e) { e.preventDefault(); }, { passive: false });
    croix.addEventListener('click', function () { fermer('croix'); });
    boutonVolet.addEventListener('click', ajouter);
    var apresChoix = function () { majPlanifiee(); setTimeout(majVolet, 120); setTimeout(majVolet, 500); setTimeout(majVolet, 1100); };
    zoneOptions.addEventListener('change', apresChoix);
    zoneOptions.addEventListener('click', apresChoix);
    panneau.addEventListener('transitionend', finFermeture);
    var y0 = null, dy = 0;
    panneau.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.idm-volet__poignee, .idm-volet__entete') || e.target.closest('.idm-volet__fermer')) return;
      y0 = e.touches[0].clientY; dy = 0; panneau.style.transition = 'none';
    }, { passive: true });
    panneau.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panneau.style.transform = 'translate3d(0,' + dy + 'px,0)';
    }, { passive: true });
    var finGlisse = function () {
      if (y0 === null) return;
      y0 = null; panneau.style.transition = ''; panneau.style.transform = '';
      if (dy > 80) fermer('glisse');
      dy = 0;
    };
    panneau.addEventListener('touchend', finGlisse, { passive: true });
    panneau.addEventListener('touchcancel', finGlisse, { passive: true });
    document.addEventListener('keydown', function (e) { if (ouvert && (e.key === 'Escape' || e.key === 'Esc')) fermer('echap'); });
  };
  var restaurer = function () {
    if (!place) return;
    var parent = place.parentNode;
    if (parent) {
      for (var i = 0; i < deplaces.length; i++) parent.insertBefore(deplaces[i], place);
      parent.removeChild(place);
    }
    place = null; deplaces = [];
  };
  var finFermeture = function (e) {
    if (e && e.type === 'transitionend' && (e.target !== panneau || (e.propertyName !== 'transform' && e.propertyName !== 'opacity'))) return;
    clearTimeout(minuterie);
    if (ouvert || !volet || !volet.classList.contains('idm-volet--visible')) return;
    volet.classList.remove('idm-volet--visible');
    restaurer();
    redescendre();
  };
  var ouvrir = function (source) {
    var f = formulaire();
    if (!f) return false;
    try {
      if (!volet) construire(f);
      clearTimeout(minuterie);
      if (!place) {
        var opts = f.querySelector('.product-options');
        if (!opts || !opts.parentNode) return false;
        var aide = opts.nextElementSibling;
        if (!aide || !aide.classList.contains('product-size-guide2')) aide = null;
        var repere = f.querySelector('.to-top-button');
        var avant = repere ? repere.getBoundingClientRect().top : 0;
        place = document.createElement('div');
        place.className = 'idm-volet-place';
        opts.parentNode.insertBefore(place, opts);
        deplaces = aide ? [opts, aide] : [opts];
        for (var i = 0; i < deplaces.length; i++) zoneOptions.appendChild(deplaces[i]);
        if (repere) {
          var ecart = avant - repere.getBoundingClientRect().top;
          if (ecart > 0) place.style.height = ecart + 'px';
        }
      }
      zoneOptions.scrollTop = 0;
      majVolet();
      if (window.MutationObserver) {
        if (!obs) obs = new MutationObserver(majPlanifiee);
        var vb = vraiBouton();
        if (vb) obs.observe(vb, { attributes: true, childList: true, characterData: true, subtree: true });
        var sp = document.getElementById('atc-sticky-price');
        if (sp) obs.observe(sp, { childList: true, characterData: true, subtree: true });
      }
      declencheur = source || null;
      if (!ouvert) {
        overflowAvant = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      ouvert = true;
      elever(f);
      volet.classList.add('idm-volet--visible');
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (ouvert) volet.classList.add('idm-volet--ouvert'); }); });
      try { volet.querySelector('.idm-volet__fermer').focus({ preventScroll: true }); } catch (_) {}
      cEvt('idm_volet_ouvert');
      return true;
    } catch (_) {
      try { restaurer(); redescendre(); if (volet) { volet.classList.remove('idm-volet--ouvert'); volet.classList.remove('idm-volet--visible'); } } catch (__) {}
      if (ouvert) { ouvert = false; document.documentElement.style.overflow = overflowAvant; }
      return false;
    }
  };
  var fermer = function (raison) {
    if (!ouvert) return;
    ouvert = false;
    if (obs) obs.disconnect();
    volet.classList.remove('idm-volet--ouvert');
    document.documentElement.style.overflow = overflowAvant;
    clearTimeout(minuterie);
    minuterie = setTimeout(finFermeture, 520);
    if (raison === 'ajout') {
      if (volet.contains(document.activeElement)) { try { document.activeElement.blur(); } catch (_) {} }
      return;
    }
    cEvt('idm_volet_ferme');
    if (declencheur) { try { declencheur.focus({ preventScroll: true }); } catch (_) {} }
  };
  var ajouter = function () {
    var s = etatBouton();
    if (s.mode === 'ajout') {
      cEvt('idm_volet_ajout');
      s.vrai.click();
      fermer('ajout');
    } else if (s.mode === 'alerte') {
      cEvt('idm_volet_alerte');
      fermer('ajout');
      s.p.click();
    }
  };

  document.addEventListener('click', function (e) {
    var barre = e.target && e.target.closest ? e.target.closest('.atc-fixed-button') : null;
    if (!barre) return;
    var f = formulaire(), vrai = vraiBouton();
    if (!f || !vrai) return;
    var zone = f.querySelector('.to-top-button') || vrai;
    var loin = !!choixDe(f) && zone.getBoundingClientRect().top > window.innerHeight * 0.5;
    if (loin && groupe === 'B' && estMobile() && ouvrir(barre)) { e.stopPropagation(); return; }
    if (loin) cEvt('idm_barre_vers_options');
    if (vrai.disabled || vrai.classList.contains('expired-to-cart')) return;
    e.stopPropagation();
    if (loin) { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    vrai.click();
  }, true);
})();



(function(){
  if(window.__IDM_ATC_DEFER_FIX__)return;
  window.__IDM_ATC_DEFER_FIX__=true;

  function attempt(){
    var orig=window.ajoutPanierSucces;
    if(typeof orig!=="function")return false;
    if(orig.__idmDeferFix)return true;
    window.ajoutPanierSucces=function(){
      var result=orig.apply(this,arguments);
      
      if(window.__DEFER_CART_OPEN__&&!document.body.classList.contains("fade-upsell")){
        window.__DEFER_CART_OPEN__=false;
        setTimeout(function(){
          if(!document.body.classList.contains("slide-cart")&&
             !document.body.classList.contains("fade-upsell")){
            try{if(typeof window.affichePanier==="function")window.affichePanier();}catch(_){}
          }
        },50);
      }
      return result;
    };
    window.ajoutPanierSucces.__idmDeferFix=true;
    return true;
  }

  if(!attempt()){var n=0,iv=setInterval(function(){if(attempt()||++n>40)clearInterval(iv);},120);}
})();


(function(){
  document.addEventListener('change', function(e){
    var input = e.target;
    if(!input || input.type !== 'radio' || !input.classList.contains('product-radio')) return;
    var option = input.closest('.product-option');
    if(!option) return;
    var label = option.querySelector('.selected-swatch-label');
    if(!label) return;
    label.textContent = input.value;
  });
})();


(function () {
  if (window.__IDM_STICKY_PRICE__) return;
  window.__IDM_STICKY_PRICE__ = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var stickySpan = document.getElementById('atc-sticky-price');
    if (!stickySpan) return;

    
    var form = document.getElementById('ajoute-panier');
    var scope = form ? (form.closest('.product-single, .shopify-section') || document.body) : document.body;
    var priceEl = scope.querySelector('.product-current-price');

    function syncPrice() {
      var text = priceEl ? (priceEl.textContent || '').trim() : '';
      var voulu = text ? ' | ' + text : '';
      if (stickySpan.textContent !== voulu) stickySpan.textContent = voulu;
    }

    syncPrice();

    
    if (priceEl) {
      new MutationObserver(syncPrice).observe(priceEl, {
        childList: true, subtree: true, characterData: true
      });
    }

    
    ['variant:change', 'product:variant-change', 'theme:variant:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(syncPrice, 60); }, true);
    });

    var labelEl = document.getElementById('atc-sticky-label');
    var mainBtn = form ? form.querySelector('.add-to-cart-button') : null;

    function syncLabel() {
      var t = (mainBtn.textContent || '').replace(/\s+/g, ' ').trim();
      if (t && labelEl.textContent !== t) labelEl.textContent = t;
      var pd = mainBtn.classList.contains('expired-to-cart') ? 'none' : '';
      if (stickySpan.style.display !== pd) stickySpan.style.display = pd;
    }

    if (labelEl && mainBtn) {
      syncLabel();
      new MutationObserver(syncLabel).observe(mainBtn, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class']
      });
    }
  });
})();


(function () {
  if (window.__IDM_TAGS_MOBILE__) return;
  window.__IDM_TAGS_MOBILE__ = true;

  if (window.innerWidth > 799) return;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;
    var sliderNav   = section.querySelector('.slider__nav');
    var sliderInner = sliderNav && sliderNav.querySelector('.slider__inner');
    var badge       = section.querySelector('.idm-product-tags');
    if (!badge || !sliderInner || !sliderNav) return;

    
    badge.style.display    = 'flex';
    badge.style.transition = 'transform .5s ease, opacity .5s ease';

    function getTx() {
      var m = (sliderInner.style.transform || '').match(/translate3d\((-?[\d.]+)/);
      return m ? parseFloat(m[1]) : 0;
    }

    function sync() {
      var tx    = getTx();
      var w     = sliderNav.offsetWidth || 1;
      var ratio = Math.min(1, Math.abs(tx) / w);
      badge.style.transform = 'translateX(' + tx + 'px)';
      badge.style.opacity   = String(Math.max(0, 1 - ratio));
    }

    
    sliderNav.addEventListener('touchstart', function () {
      badge.style.transition = 'none';
    }, { passive: true });

    
    sliderNav.addEventListener('touchend', function () {
      badge.style.transition = 'transform .5s ease, opacity .5s ease';
    }, { passive: true });

    
    new MutationObserver(sync).observe(sliderInner, {
      attributes: true, attributeFilter: ['style']
    });

    sync();
  });
})();

(function () {
  if (window.__IDM_VARIANT_URL_SYNC__) return;
  window.__IDM_VARIANT_URL_SYNC__ = true;

  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.history || typeof window.history.replaceState !== 'function') return;
  if (typeof window.MutationObserver !== 'function') return;

  var root = document.querySelector('section[data-section-type="product"] .product-details.product-single');
  if (!root) return;

  var lastId = String(root.getAttribute('data-id') || '');
  var armed = false;

  function arm(e) {
    if (armed || !e || !e.isTrusted) return;
    armed = true;
  }

  ['pointerdown', 'keydown', 'change'].forEach(function (type) {
    document.addEventListener(type, arm, { capture: true, passive: true });
  });

  function buildSearch(search, id) {
    if (/(^|[?&])variant=/.test(search)) {
      return search.replace(/([?&])variant=[^&]*/g, '$1variant=' + id);
    }
    return (search ? search + '&' : '?') + 'variant=' + id;
  }

  function syncVariantUrl() {
    var id = String(root.getAttribute('data-id') || '');
    if (!/^\d+$/.test(id) || id === lastId) return;
    lastId = id;
    if (!armed) return;

    try {
      var search = window.location.search || '';
      var nextSearch = buildSearch(search, id);
      if (nextSearch === search) return;
      window.history.replaceState(window.history.state, '', window.location.pathname + nextSearch + window.location.hash);
    } catch (e) {}
  }

  new MutationObserver(syncVariantUrl).observe(root, { attributes: true, attributeFilter: ['data-id'] });
})();

(function () {
  var script = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var BASE = script.indexOf('/assets/') > 0 ? script.slice(0, script.indexOf('/assets/') + 8) : '';
  var V = '544a';
  var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var T = {
    fr: { agrandir: 'Agrandir', aide_mobile: 'Touchez pour agrandir', geste_mobile: 'Pincez ou touchez deux fois pour zoomer', geste_pc: 'Cliquez ou utilisez la molette pour zoomer', photo: 'Agrandir la photo', sur: 'sur', fermer: 'Fermer', zoom: 'Zoomer', prec: 'Photo précédente', suiv: 'Photo suivante', erreur: 'La photo n’a pas pu être chargée.', vignettes: 'Toutes les photos', titre: 'Photos du produit' },
    en: { agrandir: 'Zoom', aide_mobile: 'Tap to zoom', geste_mobile: 'Pinch or double-tap to zoom', geste_pc: 'Click or scroll to zoom', photo: 'Enlarge photo', sur: 'of', fermer: 'Close', zoom: 'Zoom', prec: 'Previous photo', suiv: 'Next photo', erreur: 'The photo could not be loaded.', vignettes: 'All photos', titre: 'Product photos' },
    de: { agrandir: 'Vergrößern', aide_mobile: 'Zum Vergrößern tippen', geste_mobile: 'Zum Zoomen Finger spreizen oder doppelt tippen', geste_pc: 'Zum Zoomen klicken oder Mausrad drehen', photo: 'Foto vergrößern', sur: 'von', fermer: 'Schließen', zoom: 'Zoomen', prec: 'Vorheriges Foto', suiv: 'Nächstes Foto', erreur: 'Das Foto konnte nicht geladen werden.', vignettes: 'Alle Fotos', titre: 'Produktfotos' }
  };
  var L = T[lang] || T.fr;
  var tactile = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var etroit = window.matchMedia('(max-width: 799px)');
  var cEvt = function (n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (_) {} };
  var cTag = function (k, v) { try { if (typeof window.clarity === 'function') window.clarity('set', k, v); } catch (_) {} };

  var VERRE = 'background:rgba(0,0,0,.55);-webkit-backdrop-filter:blur(10px) saturate(140%);backdrop-filter:blur(10px) saturate(140%);border:1px solid rgba(255,255,255,.18);box-shadow:0 4px 12px rgba(0,0,0,.18);color:#fff;font-family:var(--body-font,system-ui),sans-serif;font-weight:600;line-height:1;letter-spacing:.04em;text-transform:var(--prod-uppercase,uppercase)';
  var ACC = 'var(--accent-color,#036635)', FOND = 'var(--body-bg,#fff)', FILET = 'var(--separation-line,#ccc)';
  var CSS = '.idm-zoom-ok{cursor:zoom-in}'
    + '.idm-zoom-badge{position:absolute;right:16px;bottom:16px;z-index:5;display:inline-flex;align-items:center;gap:8px;margin:0;padding:10px 14px;border-radius:999px;font-size:13px;cursor:zoom-in;-webkit-tap-highlight-color:transparent;transition:background .2s ease,transform .2s ease,box-shadow .2s ease;animation:idm-watch-video-cta-enter .9s cubic-bezier(.22,1,.36,1) .4s backwards;' + VERRE + '}'
    + '.idm-zoom-badge svg{width:14px;height:14px;flex:none}'
    + '.idm-zoom-badge:hover{background:rgba(0,0,0,.78);transform:translateY(-1px);box-shadow:0 6px 16px rgba(0,0,0,.25)}'
    + '.idm-zoom-badge:active{transform:translateY(0)}'
    + '.idm-zoom-badge:focus-visible{outline:2px solid ' + ACC + ';outline-offset:2px}'
    + '.idm-zoom-aide{position:absolute;top:15px;right:56px;z-index:5;padding:8px 12px;border-radius:999px;font-size:12px;white-space:nowrap;pointer-events:none;opacity:0;transform:translateY(-4px);transition:opacity .35s ease,transform .35s ease;' + VERRE + '}'
    + '.idm-zoom-aide.visible{opacity:1;transform:none}'
    + '@media (max-width:799px){.idm-zoom-badge{top:12px;right:12px;bottom:auto;width:36px;height:36px;padding:0;justify-content:center}.idm-zoom-badge .idm-zoom-txt{display:none}.idm-zoom-badge svg{width:16px;height:16px}.idm-zoom-badge::after{content:"";position:absolute;inset:-4px}}'
    + '.pswp.idm-pswp{--pswp-bg:' + FOND + ';--pswp-placeholder-bg:' + FOND + ';--pswp-icon-color:var(--close-cross,#000);--pswp-icon-color-secondary:var(--close-cross,#000);--pswp-error-text-color:var(--body-text-color,#444);--pswp-preloader-color:rgba(0,0,0,.12);--pswp-preloader-color-secondary:' + ACC + '}'
    + '.pswp.idm-pswp .pswp__top-bar{height:60px;align-items:center;background:' + FOND + ';border-bottom:1px solid ' + FILET + '}'
    + '.idm-pswp-titre{flex:1 1 auto;min-width:0;display:flex;align-items:baseline;gap:12px;padding:0 8px 0 20px}'
    + '.idm-pswp-nom{min-width:0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;color:var(--body-title-color,#000);font-family:var(--title-font,inherit);font-weight:var(--title-font-weight,400);font-style:var(--title-font-style,normal);letter-spacing:var(--title-ls,.05em);text-transform:var(--title-uppercase,uppercase);font-size:18px;line-height:1.2}'
    + '.idm-pswp-num{flex:none;color:var(--body-text-color,#444);font:600 13px/1 var(--body-font,system-ui),sans-serif;letter-spacing:.04em;font-variant-numeric:tabular-nums}'
    + '.pswp.idm-pswp .pswp__button{opacity:1}'
    + '.pswp.idm-pswp .pswp__button .pswp__icn{top:18px;left:13px;width:24px;height:24px;fill:none;color:var(--close-cross,#000)}'
    + '.pswp.idm-pswp .pswp__button:focus-visible{outline:2px solid ' + ACC + ';outline-offset:-6px}'
    + '.pswp.idm-pswp .pswp__button--arrow,.pswp.idm-pswp .pswp__button--arrow:hover,.pswp.idm-pswp .pswp__button--arrow:focus{width:44px;height:44px;margin-top:-22px;border-radius:50%;background:var(--arrow-bg-color,#036635);box-shadow:var(--arrow-shadow,0 2px 8px rgba(0,0,0,.1))}'
    + '.pswp.idm-pswp .pswp__button--arrow--prev{left:20px}'
    + '.pswp.idm-pswp .pswp__button--arrow--next{right:20px}'
    + '.pswp.idm-pswp .pswp__button--arrow .pswp__icn{top:10px;left:10px;right:auto;margin-top:0;transform:none;color:var(--arrow-color,#fff)}'
    + '.pswp.idm-pswp .pswp__button--arrow:focus-visible{outline-offset:2px}'
    + '.idm-pswp-vignettes{position:absolute;left:0;right:0;bottom:0;display:flex;justify-content:center;gap:8px;padding:12px 12px calc(12px + env(safe-area-inset-bottom,0px));overflow-x:auto;background:' + FOND + ';border-top:1px solid ' + FILET + ';scrollbar-width:none}'
    + '.idm-pswp-vignettes::-webkit-scrollbar{display:none}'
    + '.idm-pswp-vignette{flex:none;width:56px;height:56px;padding:0;border:2px solid transparent;border-radius:calc(var(--popups-radius,5) * 1px);background:' + FOND + ';overflow:hidden;cursor:pointer;opacity:.55;transition:opacity .2s ease,border-color .2s ease}'
    + '.idm-pswp-vignette:hover{opacity:1}'
    + '.idm-pswp-vignette img{width:100%;height:100%;object-fit:contain;display:block}'
    + '.idm-pswp-vignette[aria-current="true"]{border-color:' + ACC + ';opacity:1}'
    + '.idm-pswp-vignette:focus-visible{outline:2px solid ' + ACC + ';outline-offset:2px}'
    + '.idm-pswp-geste{position:absolute;left:16px;right:16px;top:calc(76px + env(safe-area-inset-top,0px));z-index:11;display:flex;justify-content:center;pointer-events:none;opacity:0;transition:opacity .35s ease}'
    + '.idm-pswp-geste span{padding:9px 14px;border-radius:999px;font-size:12px;text-align:center;' + VERRE + ';line-height:1.3}'
    + '.idm-pswp-geste.visible{opacity:1}'
    + '@supports not ((-webkit-backdrop-filter:blur(10px)) or (backdrop-filter:blur(10px))){.idm-zoom-badge,.idm-zoom-aide,.idm-pswp-geste span{background:rgba(0,0,0,.78)}}'
    + '@media (max-width:799px){.idm-pswp-nom{font-size:16px}.idm-pswp-titre{gap:10px;padding-left:16px}.pswp.idm-pswp .pswp__button--close{margin-right:2px}}'
    + '@media (prefers-reduced-motion:reduce){.idm-zoom-badge{animation:none;transition:none}.idm-zoom-aide,.idm-pswp-geste,.idm-pswp-vignette{transition:none}}';
  var LOUPE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/><path d="M10.5 7.5v6M7.5 10.5h6"/></svg>';

  var racine = null, cssPose = false, chargement = null, pswp = null, fermeParRetour = false;

  var largeurUrl = function (u, w) {
    if (!u) return u;
    u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  };
  var urlPleine = function (img) {
    var meilleur = '', lmax = 0;
    (img.getAttribute('srcset') || img.getAttribute('data-srcset') || '').split(',').forEach(function (c) { var m = c.trim().match(/^(\S+)\s+(\d+)w$/); if (m && +m[2] > lmax) { lmax = +m[2]; meilleur = m[1]; } });
    return meilleur || img.getAttribute('data-image-full') || img.currentSrc || img.src;
  };
  var visible = function (el) { return el.offsetParent !== null && getComputedStyle(el).display !== 'none'; };
  var zoomable = function (item) {
    if (!item || item.getAttribute('data-video-url') || item.classList.contains('is-photoswatch')) return null;
    var img = item.querySelector('img.image-complete-picture'); if (!img) return null;
    var w = parseInt(img.getAttribute('width'), 10), h = parseInt(img.getAttribute('height'), 10);
    return (w > 640 && h > 640) ? { img: img, w: w, h: h } : null;
  };
  var items = function () {
    if (!racine) return [];
    return Array.prototype.filter.call(racine.querySelectorAll('.slider__product .slider__inner > .slider__item'), function (it) { return visible(it) && zoomable(it); });
  };
  var poserCss = function () {
    if (cssPose) return; cssPose = true;
    var s = document.createElement('style'); s.id = 'idm-zoom-css'; s.textContent = CSS; document.head.appendChild(s);
  };
  var chargerScript = function (src) {
    return new Promise(function (ok, ko) { var s = document.createElement('script'); s.src = src; s.async = true; s.onload = ok; s.onerror = ko; document.head.appendChild(s); });
  };
  var chargerVisionneuse = function () {
    if (window.PhotoSwipe) return Promise.resolve(window.PhotoSwipe);
    if (chargement) return chargement;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = BASE + 'photoswipe.css?v=' + V; document.head.appendChild(l);
    chargement = chargerScript(BASE + 'photoswipe.umd.min.js?v=' + V).then(function () { return window.PhotoSwipe; });
    return chargement;
  };
  var habiller = function () {
    var liste = items();
    liste.forEach(function (it, i) {
      var z = zoomable(it), boite = z.img.closest('.image-complete') || it;
      if (!it.classList.contains('idm-zoom-ok')) it.classList.add('idm-zoom-ok');
      var b = boite.querySelector('.idm-zoom-badge');
      if (!b) {
        b = document.createElement('button'); b.type = 'button'; b.className = 'idm-zoom-badge';
        b.innerHTML = LOUPE + '<span class="idm-zoom-txt">' + L.agrandir + '</span>';
        if (getComputedStyle(boite).position === 'static') boite.style.position = 'relative';
        boite.appendChild(b);
      }
      var lbl = L.photo + ' ' + (i + 1) + ' ' + L.sur + ' ' + liste.length;
      if (b.getAttribute('aria-label') !== lbl) b.setAttribute('aria-label', lbl);
    });
    return liste;
  };
  var aideMobile = function () {
    if (!tactile || !etroit.matches) return;
    try { if (sessionStorage.getItem('idm_zoom_aide')) return; } catch (_) {}
    var essais = 0;
    var tenter = function () {
      if (pswp) return;
      var it = items()[0], z = it && zoomable(it); if (!z) return;
      var boite = z.img.closest('.image-complete') || it, b = boite.querySelector('.idm-zoom-badge');
      var r = b ? b.getBoundingClientRect() : null, e = null;
      if (r && r.width && r.top >= 0 && r.bottom <= window.innerHeight && r.left >= 0 && r.right <= window.innerWidth) e = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      if (!e || (e !== b && !b.contains(e))) { if (++essais < 20) setTimeout(tenter, 1500); return; }
      try { sessionStorage.setItem('idm_zoom_aide', '1'); } catch (_) {}
      var a = document.createElement('span'); a.className = 'idm-zoom-aide'; a.textContent = L.aide_mobile; a.setAttribute('aria-hidden', 'true');
      boite.appendChild(a);
      setTimeout(function () { a.classList.add('visible'); }, 300);
      setTimeout(function () { a.classList.remove('visible'); setTimeout(function () { if (a.parentNode) a.parentNode.removeChild(a); }, 400); }, 4600);
    };
    setTimeout(tenter, 1300);
  };
  var margeSure = function () {
    var d = document.createElement('div'), r = { haut: 0, bas: 0 };
    d.style.cssText = 'position:fixed;left:0;top:0;visibility:hidden;pointer-events:none;padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px)';
    document.body.appendChild(d);
    try { var c = getComputedStyle(d); r.haut = parseFloat(c.paddingTop) || 0; r.bas = parseFloat(c.paddingBottom) || 0; } catch (_) {}
    d.parentNode.removeChild(d);
    return r;
  };

  var ouvrir = function (depart) {
    var liste = items(); if (!liste.length) return;
    var index = Math.max(0, liste.indexOf(depart));
    var donnees = liste.map(function (it) {
      var z = zoomable(it), img = z.img;
      var full = urlPleine(img);
      return { src: largeurUrl(full, 2048), srcset: largeurUrl(full, 1024) + ' 1024w, ' + largeurUrl(full, 1600) + ' 1600w, ' + largeurUrl(full, 2048) + ' 2048w', width: z.w, height: z.h, msrc: img.currentSrc || img.src, alt: img.getAttribute('alt') || '', vignette: largeurUrl(full, 160), element: it };
    });
    var titreEl = document.querySelector('.product-main .product-title') || document.querySelector('h1.product-title') || document.querySelector('h1');
    var nom = titreEl ? titreEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var trait = (document.querySelector('.arrow-carousel-icon') || document.querySelector('.close-news-icon svg') || { getAttribute: function () { return null; } }).getAttribute('stroke-width') || '2';
    var icone = function (d) { return '<svg class="pswp__icn" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="' + trait + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + d + '</svg>'; };
    var sure = margeSure(), n = donnees.length;
    chargerVisionneuse().then(function (PhotoSwipe) {
      if (!PhotoSwipe || pswp) return;
      fermeParRetour = false;
      pswp = new PhotoSwipe({
        dataSource: donnees, index: index, mainClass: 'idm-pswp', bgOpacity: 1, showHideAnimationType: 'zoom', wheelToZoom: !tactile, counter: false,
        initialZoomLevel: 'fit',
        secondaryZoomLevel: function (z) { return Math.min(1, z.fit * 2.5); },
        maxZoomLevel: function (z) { return Math.max(z.fit, 1); },
        imageClickAction: 'zoom', bgClickAction: 'close', tapAction: 'toggle-controls', doubleTapAction: 'zoom',
        paddingFn: function () { return { top: 72 + sure.haut, bottom: (n > 1 ? 93 : 16) + sure.bas, left: 0, right: 0 }; },
        closeTitle: L.fermer, zoomTitle: L.zoom, arrowPrevTitle: L.prec, arrowNextTitle: L.suiv, errorMsg: L.erreur,
        closeSVG: icone('<path d="M 6 6 L 18 18 M 6 18 L 18 6"/>'),
        zoomSVG: icone('<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/><path d="M7.5 10.5h6"/><path class="pswp__zoom-icn-bar-v" d="M10.5 7.5v6"/>'),
        arrowPrevSVG: icone('<path d="M 15.5 19 L 8.5 12 L 15.5 5"/>'),
        arrowNextSVG: icone('<path d="M 8.5 19 L 15.5 12 L 8.5 5"/>'),
        returnFocus: true, preload: [1, 1]
      });
      pswp.addFilter('thumbBounds', function (bornes, data) {
        var el = data && data.element; if (!el || !bornes) return bornes;
        var r = el.getBoundingClientRect();
        return (el.offsetParent && r.width > 0 && r.left > -2 && r.right < window.innerWidth + 2 && r.bottom > 0 && r.top < window.innerHeight) ? bornes : undefined;
      });
      pswp.on('uiRegister', function () {
        pswp.ui.registerElement({
          name: 'idm-titre', order: 4, isButton: false, appendTo: 'bar', html: '',
          onInit: function (el, p) {
            el.className = 'idm-pswp-titre';
            if (nom) { var s = document.createElement('span'); s.className = 'idm-pswp-nom'; s.textContent = nom; el.appendChild(s); }
            if (n > 1) { var c = document.createElement('span'); c.className = 'idm-pswp-num'; el.appendChild(c); var maj = function () { c.textContent = (p.currIndex + 1) + ' / ' + n; }; p.on('change', maj); maj(); }
          }
        });
        if (n > 1) pswp.ui.registerElement({
          name: 'idm-vignettes', order: 30, isButton: false, appendTo: 'root', html: '',
          onInit: function (el, p) {
            el.className = 'idm-pswp-vignettes'; el.setAttribute('role', 'group'); el.setAttribute('aria-label', L.vignettes);
            var bts = donnees.map(function (d, i) {
              var b = document.createElement('button'); b.type = 'button'; b.className = 'idm-pswp-vignette';
              b.setAttribute('aria-label', L.photo + ' ' + (i + 1) + ' ' + L.sur + ' ' + n);
              var im = document.createElement('img'); im.src = d.vignette; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; b.appendChild(im);
              b.addEventListener('click', function (e) { e.stopPropagation(); p.goTo(i); });
              el.appendChild(b); return b;
            });
            var maj = function () { bts.forEach(function (b, i) { b.setAttribute('aria-current', i === p.currIndex ? 'true' : 'false'); }); var a = bts[p.currIndex]; if (a && a.scrollIntoView) { try { a.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (_) {} } };
            p.on('change', maj); maj();
          }
        });
      });
      var geste = null, zoome = false;
      var cacherGeste = function () { if (geste) geste.classList.remove('visible'); };
      pswp.on('zoomPanUpdate', function (e) { if (!zoome && e.slide && e.slide.currZoomLevel > e.slide.zoomLevels.initial * 1.05) { zoome = true; cacherGeste(); cEvt('idm_zoom_utilise'); } });
      pswp.on('afterInit', function () {
        var el = pswp.element; if (!el) return;
        el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', nom ? nom + ' — ' + L.titre : L.titre);
        var deja = false; try { deja = !!sessionStorage.getItem('idm_zoom_geste'); sessionStorage.setItem('idm_zoom_geste', '1'); } catch (_) {}
        if (deja) return;
        geste = document.createElement('div'); geste.className = 'idm-pswp-geste'; geste.setAttribute('aria-hidden', 'true');
        var s = document.createElement('span'); s.textContent = tactile ? L.geste_mobile : L.geste_pc; geste.appendChild(s);
        el.appendChild(geste);
        setTimeout(function () { if (geste && !zoome) geste.classList.add('visible'); }, 550);
        setTimeout(cacherGeste, 3600);
      });
      pswp.on('close', function () {
        cacherGeste();
        if (!fermeParRetour && history.state && history.state.idmZoom) { try { history.back(); } catch (_) {} }
      });
      pswp.on('destroy', function () { pswp = null; });
      try { history.pushState({ idmZoom: 1 }, ''); } catch (_) {}
      pswp.init();
      cEvt('idm_zoom_ouvert'); cTag('idm_zoom_photo', String(index + 1));
    }).catch(function () {
      var full = liste[index] && urlPleine(zoomable(liste[index]).img);
      if (full) window.open(largeurUrl(full, 2048), '_blank', 'noopener');
    });
  };

  window.addEventListener('popstate', function () { if (pswp) { fermeParRetour = true; pswp.close(); } });

  // 19/10/2026 (Clarity : zoom actif sur 98 % des fiches ordinateur mais 74 % sur téléphone, 0 % sur les fiches à photos par
  // couleur / modèle) : ce démarrage a lieu PENDANT l'exécution de ce fichier, avant que la galerie soit prête (classe
  // cls-slider-ready posée plus tard, theme.js pas encore exécuté). Sous 800 px, la réservation anti-CLS des sections produit
  // n'affiche alors que la diapositive « active » ; et sur une fiche à photos par couleur, applyMediaFilter() vient de retirer
  // « active » partout : AUCUNE photo visible (sonde du banc : 0 sur 11 pour ocarina-ceramique, 0 sur 12 pour
  // tongue-drum-gamme-majeur), items() était vide et le zoom ne démarrait JAMAIS sur la page. On démarre désormais dès qu'une photo
  // du carrousel PEUT être agrandie (visible ou non) ; les photos sont habillées quand elles deviennent visibles (observateur
  // posé sur tout le carrousel, classe cls-slider-ready comprise).
  var demarrer = function () {
    racine = document.querySelector('.product-main .product-images') || document.querySelector('.product-images');
    if (!racine || !BASE) return;
    var slider = racine.querySelector('.slider__product'); if (!slider) return;
    var candidates = Array.prototype.filter.call(slider.querySelectorAll('.slider__inner > .slider__item'), function (it) { return !!zoomable(it); });
    if (!candidates.length) return;
    poserCss(); habiller(); aideMobile(); cTag('idm_zoom', 'actif');
    var x0 = 0, y0 = 0, bouge = false;
    slider.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; bouge = false; }, { passive: true });
    slider.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - x0) > 8 || Math.abs(e.clientY - y0) > 8) bouge = true; }, { passive: true });
    slider.addEventListener('click', function (e) {
      var it = e.target.closest('.slider__inner > .slider__item'); if (!it || !zoomable(it)) return;
      var badge = e.target.closest('.idm-zoom-badge');
      if (!badge && bouge) return;
      if (!badge && e.target.closest('a[href], button, input, select, textarea, label, [role="button"], .slider__previous, .slider__next')) return;
      e.preventDefault(); e.stopPropagation();
      ouvrir(it);
    }, true);
    if (!tactile) slider.addEventListener('mouseenter', function () { chargerVisionneuse(); }, { once: true, passive: true });
    var plan = 0;
    if (window.MutationObserver) new MutationObserver(function () { if (!plan) plan = requestAnimationFrame(function () { plan = 0; habiller(); }); }).observe(slider, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
